<template>
	<personal-layout cur-menu="tradelist">
		<div class="right-box">
			<div class="flex-row back-box">
				<i class="el-icon-arrow-left back-btn" @click="goBack"></i>
				<div class="title">订单明细</div>
			</div>
			<div class="status-box">
				<div>
					<div class="trade-status" v-if="tradeDetail.tradeStatus == '5020'">销售单状态：原始单-被合并
					</div>
					<div class="trade-status" v-else-if="tradeDetail.tradeStatus == '5030'">销售单状态：原始单-被拆分
					</div>
					<div class="trade-status" v-else>
						销售单状态：{{ !!tradeDetail.tradeStatusExplain && tradeDetail.tradeStatusExplain.indexOf('代销发货') >= 0 ? '待发货'
							: tradeDetail.tradeStatusExplain }}
					</div>
					<div class="trade-status" v-if="sellbackInfo.sellbackStatusExplain">
						售后单状态：{{ sellbackInfo.sellbackStatusExplain }}</div>
				</div>

				<div class="trade-log flex-row" v-show="isShowTrailInfo" @click="showTradeLog">
					<div class="simple-info" v-show="false"> {{ simpleTrailInfo }}</div>
					<div class="log-btn">物流轨迹</div>
				</div>
			</div>
			<div class="info-box" v-if="tradeDetail.logisticType == '1' || tradeDetail.logisticType == '3'">
				<div class="small-title">收件人信息</div>
				<div class="base-info">
					<div><span class="base-item">姓名：</span><span>{{ tradeReceiver.receiverName }}</span></div>
					<div><span class="base-item">电话：</span><span>{{ tradeReceiver.mobile }}</span></div>
					<div><span class="base-item">地址：</span><span v-if="tradeReceiver.province">{{ tradeReceiver.province
					}}&nbsp;</span><span v-if="tradeReceiver.city">{{ tradeReceiver.city }}&nbsp;</span><span
							v-if="tradeReceiver.town">{{ tradeReceiver.town }}&nbsp;</span><span v-if="tradeReceiver.district">{{
								tradeReceiver.district }}&nbsp;</span><span v-if="tradeReceiver.country != '中国'">{{ tradeReceiver.country
							}}&nbsp;</span><span v-if="tradeReceiver.address">{{ tradeReceiver.address }}</span></div>
				</div>
				<div class="address-editbtn" @click="openAddressEdit"
					v-if="tradeDetail.isAllowEditTradeAddress && config.isAllowEditTradeAddress">修改地址</div>
			</div>
			<div class="info-box" v-else-if="tradeDetail.logisticType == '2'">
				<div class="small-title">自提信息</div>
				<div class="base-info">
					<div><span class="base-item">自提点：</span><span>{{ tradeDetail.channelAnotherName }}</span></div>
					<div><span class="base-item">地 点：</span><span>{{ tradeReceiver.address }}</span></div>
					<div><span class="base-item">自提人：</span><span>{{ tradeReceiver.receiverName }} &nbsp;
							{{ $utils.regTel(tradeReceiver.mobile) }}</span></div>
				</div>
			</div>
			<div class="info-box">
				<div class="small-title">订单信息</div>
				<div class="base-info">
					<el-row :gutter="20">
						<el-col :span="tradeDetail.logisticType != '2' ? 12 : 24">
							<div><span class="base-item">交易时间：</span><span>{{ tradeDetail.tradeTime }}</span></div>
							<div><span class="base-item">订单编号：</span><span>{{ tradeDetail.tradeNo }}</span><span
									v-show="tradeDetail.tradeNo" class="copy-btn" v-clipboard:copy="tradeDetail.tradeNo"
									v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></div>
							<div><span class="base-item">原始单号：</span><span>{{ tradeDetail.sourceTradeNo }}</span><span
									v-show="tradeDetail.sourceTradeNo" class="copy-btn" v-clipboard:copy="tradeDetail.sourceTradeNo"
									v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></div>
						</el-col>
						<el-col :span="12" v-show="tradeDetail.logisticType != '2'">
							<div><span class="base-item">物流公司：</span><span>{{ tradeDetail.logisticName || "" }}</span></div>
							<div><span class="base-item">物流单号：</span><span>{{ tradeDetail.mainPostid || "" }}</span></div>
							<div class="flex-row">
								<div class="base-item">备注：</div>
								<div>{{ tradeDetail.buyerMemo }}</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="info-box">
				<div class="small-title">商品清单</div>
				<goods-list :isShowSingleSpec="isShowSingleSpec" :goodslist="tradeGoods" :decimalDigits="decimalDigits"></goods-list>
			</div>
			<div v-if="uploadFiles.length>0"  style="padding:0 20px;">
				<div class="small-title" style="margin-bottom:20px;">附件内容({{uploadFiles.length}})</div>
				<template>
					<div class="dropdown-wrapper">
						
							<el-input
								v-model="fileContent"
								readonly
								@click.native="showDropdown = !showDropdown"
								class="contentInput"
								:title="fileContent"
								:suffix-icon="showDropdown ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
							/>
						
						<!-- 自定义下拉内容 -->
						 <transition name="slide-fade">
							<div v-show="showDropdown" class="custom-dropdown">
								<div class="itemDown" v-for="(item,index) in uploadFiles" :key="item.label">
									<div class="downName">
										{{item.label}}
									</div>
									<div class="downIcon">
										<div style="margin-right:10px;" v-if="isImage(item.label)">
											<i class="el-icon-view"></i>
											<span style="margin-left:5px;" @click="previewImg(item.previewUrl,index)">预览</span>
										</div>
										<div v-else style="margin-right:10px;">
											<!-- 占位内容，保持相同的宽度和高度 -->
											<span style="visibility: hidden;">
												<i class="el-icon-view"></i>
												<span style="margin-left:5px;">预览</span>
											</span>
										</div>
										<div>
											<i class="el-icon-download"></i>
											<span style="margin-left:1px;" @click="downloadFile(item.downloadUrl,item.label)">下载</span>
										</div>
									</div>
								</div>
							</div>
						 </transition>
						
					</div>
				</template>
			</div>
			<el-image
				v-if="previewVisible"
				:src="newPreviewUrl"
				:preview-src-list="previewList"
				:initial-index="previewIndex"
				:hide-on-click-modal="true"
				@close="previewVisible = false"
				ref="imagePreview"
				style="display: none;visibility: hidden;"
				>
    		</el-image>
			<div class="info-box total-box">
				<el-form label-position="right" label-width="100px" class="flex-col">
					<el-form-item label="商品总数 :">
						<div class="money-text">x {{ $utils.filterTrailingZeros(tradeDetail.tradeCount, (typeof decimalDigits === 'number' ? decimalDigits : 0)) }}</div>
					</el-form-item>
					<el-form-item label="优    惠 :" v-if="tradeDetail.discountFee > 0">
						<div class="money-text">
							{{ $currency.symbol }}{{ $utils.amountFixed(tradeDetail.discountFee, 2) }}
						</div>
					</el-form-item>
					<el-form-item label="运    费 :">
						<div class="money-text">
							{{ $currency.symbol }}{{ $utils.amountFixed(tradeDetail.receivedPostFee, 2) }}
						</div>
					</el-form-item>
					<el-form-item label="货品积分 :" v-if="tradeDetail.goodsScoreTotal > 0">
						<div class="money-text">
							{{ tradeDetail.goodsScoreTotal }}积分
						</div>
					</el-form-item>
					<el-form-item label="抵扣积分 :" v-if="tradeDetail.deductionScoreTotal > 0">
						<div class="money-text">
							{{ tradeDetail.deductionScoreTotal }}积分
						</div>
					</el-form-item>
					<el-form-item label="订单共计 :">
						<div class="money-text total">
							<span v-show="tradeDetail.payment > 0 || tradeDetail.pointTotal == 0">{{ $currency.symbol }}{{
								$utils.amountFixed(tradeDetail.payment,
									2) }}</span>
							<span v-show="tradeDetail.payment != 0 && tradeDetail.pointTotal > 0"> + </span>
							<span v-show="tradeDetail.pointTotal > 0">{{ tradeDetail.pointTotal }}</span>
							<span v-show="tradeDetail.pointTotal > 0" class="score-text">积分</span>
						</div>
					</el-form-item>
					<div class="refund-button-div">
						<!-- 测试代码 -->
						<!-- <el-button plain @click="showReturnGoodsDialog()">申请退货</el-button> -->
						<div v-if="tradeDetail.canRefundType == 1">
							<el-button v-if="sellbackInfo.sellbackStatus == -1 || sellbackInfo.sellbackStatus == 1" plain
								@click="showRefundDialog()">
								申请退款
							</el-button>
							<el-button v-else disabled plain>{{ sellbackInfo.sellbackStatusExplain }}</el-button>
						</div>
						<div v-if="tradeDetail.canRefundType == 2">
							<el-button plain @click="showReturnGoodsDialog()">申请退货</el-button>
						</div>
					</div>
				</el-form>
			</div>
			<!-- 退款弹窗 -->
			<div>
				<el-dialog :model="refundForm" title="退款原因" :visible.sync="dialogVisible" width="400px" center>
					<el-form style="margin: 0 auto;width: 300px;">
						<el-form-item>
							<el-select v-model="refundForm.reson">
								<el-option v-for="item in refundResonList" :key="item" :value="item"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-input rows="8" type="textarea" placeholder="请输入备注" v-model="refundForm.remark">
							</el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button plain @click="refundBtn()">确 定</el-button>
						<el-button @click="dialogVisible = false">取 消</el-button>
					</span>
				</el-dialog>
			</div>
			<div>
				<el-dialog title="退货申请" :showClose="false" :visible.sync="isShowReturnGoodsDialog" width="550px"
					:close-on-click-modal="false">
					<div class='return-goods-box'>
						<el-table ref="selectedReturnGoodsList" :data="canReturnGoodsList" style="width: 500px" :show-header="false"
							@selection-change="selectReturnGoods">
							<el-table-column type="selection" width="50">
							</el-table-column>
							<el-table-column label="图片" width="80">
								<template slot-scope="scope">
									<img :src="$utils.setImg(scope.row.sourcePicUrl || scope.row.picUrl)" style="height: 50px" />
								</template>
							</el-table-column>
							<el-table-column label="商品信息" width="200" prop="goodsName,specName,unit,sellPrice,sellCount">
								<template slot-scope="scope">
									<div>{{ scope.row.goodsName }}</div>
									<div v-if="config.isShowGoodsNo" class="text-ellipsis_oneline">{{ scope.row.goodsNo }}</div>
									<div>{{ scope.row.specName }} - {{ scope.row.unit }}</div>
									<span>{{ $currency.symbol }}{{ $utils.filterTrailingZeros(scope.row.sellPrice) }}</span>
								</template>
							</el-table-column>
							<el-table-column label="计数器" prop="sellCount,maxReturnCount">
								<template slot-scope="scope">
									<el-input-number class="number" v-model="scope.row.returnCount"
										:min="scope.row.returnCount % 1 !== 0 ? scope.row.returnCount : 1"
										:max="scope.row.maxReturnCount"
										:precision="scope.row.returnCount % 1 !== 0 ? (typeof decimalDigits === 'number' ? decimalDigits : 2) : 0"
										size="mini" label="退货数量" :disabled="scope.row.returnCount % 1 !== 0"
										@change="changeReturnCount(scope.$index, $event)">
									</el-input-number>
								</template>
							</el-table-column>
							<div slot="append">
								<div class="info_footer">
									<el-checkbox class="allCheck" :indeterminate="isIndeterminate" v-model="isSelectAllReturnGoods"
										@change="selectAllReturnGoods()">全选</el-checkbox>
									<span class="span_footer">数量：{{ $utils.filterTrailingZeros(sumCount, (typeof decimalDigits === 'number' ? decimalDigits : 0)) }}</span>
								</div>
							</div>
						</el-table>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button plain @click="showReturnMainDialog()">确 定</el-button>
						<el-button @click="isShowReturnGoodsDialog = false">取 消</el-button>
					</span>
				</el-dialog>
			</div>
		</div>
		<div class="dialogBox">
			<el-dialog class="detailDialog" title="查看轨迹" :visible.sync="trajectoryShow"
				style="margin-left: 28%;width:880px;overflow: hidden;">
				<iframe :src="webviewSrc" style="border: none; width: 402px; height: 628px;"></iframe>
			</el-dialog>
		</div>
		<el-dialog :visible.sync="dialogVisible2">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		<!-- 退货物流信息弹窗 -->
		<div>
			<el-dialog title="退货信息填写" :visible.sync="isShowReturnMainDialog" width="490px" class="dialogClass"
				custom-class="return-dialog" :close-on-click-modal="false">
				<el-form :model="refundLogistics" ref="refundLogistics" style="width: 80%; margin: 0 auto;">
					<div class='refund-address' v-if="isOpenShowSellBackAddress">
						<div class='address-title'>
							<div style="font-weight: 600;">退货地址</div>
							<div style="display: flex;align-items: center;cursor: pointer;color:#668BE8"
								@click="copySellBackAddress()">
								<img src="../../assets/images/icon-copy.svg" style="height: 20px;margin-right: 4px;" />复制
							</div>
						</div>
						<div class='address-reciver'>
							<div class='reciver-item'>{{ sellBackAddressInfo.sellerName }}</div>
							<div class='reciver-item' style="text-align: right;">{{ sellBackAddressInfo.sellerTel }}</div>
						</div>
						<div class='address-detail'>
							{{ sellBackAddressInfo.sellerAddress }}
						</div>
					</div>
					<el-form-item label="退款金额" :rules="refundGoodsRules.sellBackApplyAmount" prop="sellBackApplyAmount">
						<el-input v-model="refundLogistics.sellBackApplyAmount" oninput="value=value.replace(/[^0-9.]/g,'')"
							:placeholder="returnPlaceHolder" />
					</el-form-item>
					<el-form-item label="物流方式">
						<el-select v-model="refundLogistics.logisticName" value-key="logisticId"
							style="width: 100%;min-width: 320px;">
							<el-option v-for="item in logisticsWays" :label="item.logisticName" :key="item.logisticId"
								:value="item.logisticName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="物流单号" :rules="refundGoodsRules.postId" prop="rcv_post_id">
						<el-input v-model="refundLogistics.rcv_post_id" style="100%;"></el-input>
					</el-form-item>
					<el-form-item label="退货原因" :rules="refundGoodsRules.refundReason" prop="reason">
						<div class="radio-group">
							<el-radio v-for="item in refundGoodsReson" v-model="refundLogistics.reason" :label="item"
								style="width:100px;margin-top: 5px;margin-bottom: 5px;"></el-radio>
						</div>
					</el-form-item>
					<!-- <el-form-item label="退货附件" v-if="isOpenOrderBackAttachments">
						<el-upload accept=".jpg,.jpeg,.png" :limit="3" :action="configs.uploadFileUrl" list-type="picture-card" :data="{
							userName: userName,
							fileClass: 'fileImg',
						}" :on-preview="_handlePictureCardPreview" :on-exceed="_handlePictureCardExceed" :on-success="_handleSuccess">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item> -->
					<div v-if="isOpenOrderBackAttachments"  class="upload-wrapper">
						<div class="el-form-item is-required">
							<label class="el-form-item__label">
								<span>{{OrderBackAttachmentsRemind}}</span>
							</label>
						</div>
						<el-upload accept=".jpg,.jpeg,.png" :limit="3" :action="configs.uploadFileUrl" list-type="picture-card" :data="{
							userName: userName,
							fileClass: 'fileImg',
						}" :on-preview="_handlePictureCardPreview" :on-remove="removeFiles" :on-exceed="_handlePictureCardExceed" :on-success="_handleSuccess">
							<i class="el-icon-plus"></i>
						</el-upload>
					</div> 
					<el-form-item label="备注留言">
						<el-input type="textarea" v-model="refundLogistics.remark" style="100%;"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button plain @click="returnBtn()">确 定</el-button>
					<el-button @click="isShowReturnMainDialog = false">取 消</el-button>
				</span>
			</el-dialog>
		</div>
		<address-edit v-if="showEditDialog" :addressinfo="currentAddr" :isFromTradeDetail="true" title="修改地址"
			:isCreate="createEditDialog" :isShow="showEditDialog" @close="closeEditDialog"
			@success="editSuccess"></address-edit>
		<trade-logistic :isShow="showLogDialog" :tradeId="tradeDetail.tradeId" :tradeNo="tradeDetail.tradeNo"
			:logisticId="tradeDetail.logisticId" :logisticNo="tradeDetail.logisticNo" :mobile="tradeReceiver.mobile" @hastrailinfo="hasTrailInfo"
			@close="closeLogDialog"></trade-logistic>
	</personal-layout>
	
</template>

<script>
import '../../theme/element/theme/self.css';
import _ from 'lodash';
import personalLayout from '../../components/mine/PersonalLayout.vue';
import goodsList from '../../components/trade/GoodsListJmc.vue';
import tradeLogistic from '../../components/trade/TradeLogistic.vue';
import commonUtils from '../../utils/common-utlis.js';
import tradeApi from '../../utils/api-utils/api-trade.js';
import refundApi from '../../utils/api-utils/api-refund.js';
import addressApi from '../../utils/api-utils/api-address.js';
import {
	getCustomerInfo
} from '../../utils/api-utils/api-customer.js';
import {
	getParam
} from '../../utils/api-utils/api-params.js';
import {
	callFeign
} from '../../utils/api-utils/api-callFeign.js';
import {
	addJackyunLog
} from '../../utils/api-utils/api-jackyunlog.js';
import {
	system
} from '../../utils/api-utils/api-sys.js';
	import {
		config
	} from '../../config.js';
import addressEdit from '../../components/trade/AddressEdit.vue';
export default {
	name: 'tradedetail',
	components: {
		personalLayout,
		goodsList,
		tradeLogistic,
		addressEdit
	},

	data() {
		const validateMoney = (rule, val, callback) => {
			let that = this;
			if (val.length == 0) {
				callback("请输入退款金额");
			}
			let num = val.toString(); //先转换成字符串类型
			if (num.indexOf('.') == 0) { //第一位就是 .
				num = '0' + num;
			}
			num = num.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			num = num.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			num = num.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (num.indexOf(".") < 0 && num != "") {
				num = parseFloat(num);
			}
			if (num > that.maxReturnAmount) {
				num = that.maxReturnAmount;
			}
			that.refundLogistics.sellBackApplyAmount = num;
			callback();
		};
		return {
			dialogImageUrl: '',
				dialogVisible2: false,
			configs: config, //获取url参数
				attachList: [], // 附件urlList
			isOpenOrderBackAttachments: false,
			OrderBackAttachmentsRemind: '',
			previewList: [],
				newPreviewUrl: '',
				previewIndex: 0,
				previewVisible: false,
				fileContent: '',
				uploadFiles: [
				],
				showDropdown: false,
			tradeNo: "", //this.$route.params.tradeNo, //接收上一个页面的传值
			tradeDetail: {},
			tradeReceiver: {},
			jmallTradeDetail: {},
			tradeGoods: [],
			statusText: ['已取消', '待付款', '待审核', '待发货', '已发货', '已完成', '', '', '', '退款中', '退款完成', '', '', '', '退货中',
				'退货完成'
			],
			isShowTrailInfo: false, //是否有订单轨迹相关信息
			simpleTrailInfo: '', //简易物流信息
			showLogDialog: false, //是否展示物流轨迹	
			dialogVisible: false, //退款弹窗
			isShowReturnGoodsDialog: false, //退货弹窗
			isShowReturnMainDialog: false, //退货物流信息弹窗
			refundResonList: ["拍错/多拍", "不想要了", "订单信息有误", "其他"],
			refundForm: {
				reson: '',
				remark: '',
			},
			customer: {}, //顾客信息
			isSelectAllReturnGoods: false, // 全选
			refundGoodsSelection: [], //选中退货商品信息
			isIndeterminate: false, // 全选确定状态
			sumCount: 0, //退货数量
			sumScore: 0, //退货积分
			//退货物流信息
			refundLogistics: {
				logisticId: '',
				logisticName: '',
				rcv_post_id: '',
				reason: '卖家发错货',
				remark: '',
				sellBackApplyAmount: ''
			},
			logisticsWays: [], // 物流方式
			refundGoodsReson: ["卖家发错货", "做工问题", "描述不符", "其他"], //退货原因
			refundGoodsRules: {
				postId: [{
					required: true,
					message: '请输入物流单号',
					trigger: 'blur'
				}],
				refundReason: [{
					required: true,
					message: '请选择退货原因',
					trigger: 'change'
				}],
				sellBackApplyAmount: [{
					required: true,
					trigger: 'change',
					validator: validateMoney

				}]
			},
			subTradeList: [],
			sellbackStatus: '', //退款状态
			sellbackType: '', // 退款类型
			isClickRefund: true, // 退款/退货按钮显示/不显示
			reFundList: [], // 退货数据列表\
			isShowSingleSpec: true, // 是否展示单规格
			logisticName: "", // 订单物流名称
			trajectoryShow: false,
			webviewSrc: "",
			config: {
				isOpenCannotReturnTime: false,
				cannotReturnDays: 0
			},
			returnPlaceHolder: "",
			omsTradeInfo: {}, // 原始销售单信息
			originalTradeList: [], // 原始单列表
			originalTradeGoodsList: [], // 原始单商品列表（多个订单的货品合并到一起，并附加一些订单信息到商品上）
			sellbackInfo: {}, // 当前订单的退款信息
			canReturnGoodsList: [], // 可退货商品列表
			selectedReturnGoodsList: [], // 选中的退货商品列表
			maxReturnAmount: 0, // 最大可退金额
			currentAddr: {},
			createEditDialog: false,
			showEditDialog: false,
			sellBackAddressInfo: {},
			isOpenShowSellBackAddress: false,
			ticketIds: [], // ticketId集合,退款退货使用
			hasEleTicket: false, // 是否含电子票订单
			decimalDigits: 0, // 小数位数
		};
	},
	created() {
		// 默认绑定退款原因(拍错/多拍)
		this.refundForm.reson = this.refundResonList[0];
	},
	async mounted() {
		// 接收参数	
		await this._getParams();

		// 获取订单详情
		await this._getTradeDetail();

		// 加载当前订单的退款信息
		this._loadSellbackInfo();

		// 获取退货地址
		this._getSellBackAddress();
	},
	computed: {
			userName() {
				return localStorage.getItem('SubMemberName') || localStorage.getItem('JackyunUserName')
			}
		},
	methods: {
		/**
			 * 附件上传
			 */
			_handlePictureCardPreview(response, file, fileList) {
				this.dialogImageUrl = response.response.error_info;
				this.dialogVisible2 = true;
			},
			_handlePictureCardExceed(files, fileList) {
				this.$message.error("附件数量不可超出3个")
			},
			_handleSuccess(response, file, fileList) {
				console.log('fileList',fileList)
				let tmp = [];
				this.attachList = [];
				if (response.error_code == "0") {
					tmp = fileList.map((item,index)=>{
						let num = index+1
						return {
							fileName: '附件'+num+item.response.error_info.substring(item.response.error_info.lastIndexOf('.')).toLowerCase(),
							url: item.response.error_info
						}
					})
					this.attachList = tmp
				}
			},
			removeFiles(file, fileList) {
				//console.log('fileList===',fileList)
				let tmp = [];
				tmp = fileList.map(item=>{
						return {
							fileName: item.name,
							url: item.response.error_info
						}
					})
					this.attachList = tmp
			},
		hasTrailInfo(hasInfo, info) {
			this.isShowTrailInfo = hasInfo;
			this.simpleTrailInfo = info;
		},
		showTradeLog() {
			this.showLogDialog = true;
		},
		closeLogDialog() {
			this.showLogDialog = false;
		},
		//获取吉客云订单明细
		async _getTradeDetail() {
			let omsTradeInfo = await tradeApi.getOmsTradeDetail(this.tradeNo);
			if (!omsTradeInfo.tradeId) {
				this.$message.error({
					message: '订单不存在'
				});
				commonUtils.backPage();
			}

			console.log('oms',omsTradeInfo)
			//jmc的都是已经推到oms的，所以需要取oms的附件
			//交易关闭，待结算取商城attachUrls的值,其余状态单子，都是已经推单到oms的，所以取oms销售单里的附件；
			//检查oms销售单那边有没有上传的附件,如果有，直接拿，如果没有不显示附件
			if(omsTradeInfo.tradeOrderExtra&&omsTradeInfo.tradeOrderExtra.extraData){
				try {
					let omsFile = JSON.parse(omsTradeInfo.tradeOrderExtra.extraData)&&JSON.parse(omsTradeInfo.tradeOrderExtra.extraData).goodsAttachDtoArr||[];
					console.log('omsFile',omsFile);
					if(omsFile.length>0){
						this.uploadFiles = omsFile.map((item,index)=>{
							return {
								label: item.fileName,
								previewUrl: item.fileUrl,
								downloadUrl: item.fileUrl
							}
						})
						this.fileContent = this.uploadFiles.map(item=>{return item.label}).join(',')||'';
						this.previewList = this.uploadFiles.map(item=>{return item.previewUrl})||[];
					}else{
						this.uploadFiles = []
					}
				}
				catch {
					this.uploadFiles = []
				}
				
			}
			// 获取吉商城图片列表
			let picList = await tradeApi.getPicByTradeNoList([omsTradeInfo.sourceTradeNo]);

			// 获取原始单列表
			let originalTradeList = await this._getOriginalTradeList(omsTradeInfo.sourceTradeNo);
			this.originalTradeList = originalTradeList;
			// console.log('originalTradeList[0]',originalTradeList[0])
			// if(originalTradeList[0].attachUrls&&this.uploadFiles.length===0){
			// 		let tmpArr = originalTradeList[0].attachUrls.split(';')||[];
			// 		this.uploadFiles = tmpArr.map((item,index)=>{
			// 			let num = 0;
			// 			num = index+1;
			// 			return {
			// 				label: '附件'+num,
			// 				previewUrl: item,
			// 				downloadUrl: item
			// 			}
			// 		})
			// 		this.fileContent = this.uploadFiles.map(item=>{return item.label}).join(',')||'';
			// 		this.previewList = this.uploadFiles.map(item=>{return item.previewUrl})||[];
			// 	}
			this.hasEleTicket = originalTradeList.some(item => item.includeShoppingCardType);
			
			// 是否包含ssy订单
			this.hasSsyTrade = originalTradeList.some(item => item.isSsy);

			// 生成原始单货品列表（多个订单的货品合并到一起，并附加一些订单信息到商品上）
			let originalTradeGoodsList = this._getOriginalTradeGoodsList(originalTradeList);
			this.originalTradeGoodsList = originalTradeGoodsList;

			// 将oms商品列表和原始商品匹配
			this._matchOriginalTradeGoodsList(omsTradeInfo, originalTradeGoodsList);

			let tradeDetail = omsTradeInfo.tradeOrder; //订单信息
			tradeDetail.mainPostid = (tradeDetail.mainPostid || "") + (omsTradeInfo
				.extraLogisticNo ? ("," + omsTradeInfo.extraLogisticNo || "") : "");
			tradeDetail.tradeStatusExplain = tradeDetail.tradeStatusExplain.split('-')[0];
			// 订单状态说明
			tradeDetail.tradeStatusExplain = tradeDetail.tradeStatusExplain.split('-')[0];
			if (tradeDetail.tradeStatus == 5020) {
				tradeDetail.tradeStatusExplain = "原始单-被合并";
			} else if (tradeDetail.tradeStatus == 5030) {
				tradeDetail.tradeStatusExplain = "原始单-被拆分";
			} else if (tradeDetail.tradeStatusExplain.includes("代销发货")) {
				tradeDetail.tradeStatusExplain = "待发货";
			}
			tradeDetail.tradeOrderPayArr = omsTradeInfo.tradeOrderPayArr; // 支付金额信息
			tradeDetail.tradeOrderPayArr.forEach(item => {
				item.payment = item.payment.toFixed(2);
			});

			// 订单解密
			await tradeApi.tradeDecrypt(omsTradeInfo);
			
			// 地址信息
			this._setAddressInfo(omsTradeInfo);

			let tradeGoods = omsTradeInfo.tradeOrderGoodsArr; //货品信息
			let tradeReceiver = omsTradeInfo.tradeOrderReceiver; //收件信息

			this.ticketIds = tradeGoods.filter(item => item.ticketId).map(item => item.ticketId);

			//格式化订单总价
			tradeDetail.payment = parseFloat(tradeDetail.payment).toFixed(2);
			//重新封装货品信息
			for (let i = 0; i < tradeGoods.length; i++) {
				tradeGoods[i].pic0 = picList.filter(item => item.specId == tradeGoods[i].skuId && !!item.picUrl)[0] && picList.filter(item => item.specId == tradeGoods[i].skuId && !!item.picUrl)[0].picUrl;
				//提取货品图片
				if (tradeGoods[i].skuImgUrl) {
					let picInfo = JSON.parse(tradeGoods[i].skuImgUrl);
					tradeGoods[i].pic400 = picInfo.pic400x400;
					tradeGoods[i].pic50 = picInfo.pic50x50;
					tradeGoods[i].pic0 = tradeGoods[i].pic0 || picInfo.pic0x0;
				} else {
					tradeGoods[i].pic400 = '/Images/MobileUse/default.png';
					tradeGoods[i].pic0 = tradeGoods[i].pic0 || '/Images/MobileUse/default.png';
				}
				tradeGoods[i].picUrl = tradeGoods[i].sourcePicUrl || tradeGoods[i].pic0;
				//格式化货品单价
				// tradeGoods[i].sellPrice = parseFloat(tradeGoods[i].sellPrice).toFixed(2);
				//格式化货品总价
				tradeGoods[i].sellTotal = parseFloat(tradeGoods[i].sellTotal).toFixed(2);
			}
			if (this.config.channelAnotherNameList) {
				let matchObj = this.config.channelAnotherNameList.find((anotherNameItem) => tradeDetail.logisticId == anotherNameItem.channelId);
				let logisticName = matchObj && matchObj.channelAnotherName;
				tradeDetail.channelAnotherName = logisticName || tradeDetail.logisticName;
			}

			// 检测并生成允许退款/退货的类型（0 不可退，1 可退款，2 可退货）
			tradeDetail.canRefundType = await this.__getCanRefundTypeByJackyunTradeStatus(tradeDetail);

			// 是否允许修改地址
			tradeDetail.isAllowEditTradeAddress = ![9090, 6000, 5030, 5020, 5010].includes(tradeDetail.tradeStatus);

			//渲染订单详情界面			       
			this.tradeDetail = tradeDetail;
			this.refundGoodsRules.postId[0].required = tradeDetail.logisticType != 2;
			this.__getLogisticByLogisticId(tradeDetail.logisticId, tradeDetail.logisticName);
			this.tradeReceiver = tradeReceiver;
			this.tradeGoods = tradeGoods;
			//获取商城商品图片
			this.webviewSrc = "https://m.kuaidi100.com/result.jsp?nu=" + tradeDetail.mainPostid;
			this.omsTradeInfo = omsTradeInfo;
		},

		/**
		 * 设置地址信息
		 */
		async _setAddressInfo(omsTradeInfo) {
			let tradeOrderReceiver = omsTradeInfo.tradeOrderReceiver;
			let addressInfo = await addressApi.addressrAnalyze(tradeOrderReceiver.address.replace(/\s*/g, ""));
			this.currentAddr = {
				name: tradeOrderReceiver.receiverName,
				tel: tradeOrderReceiver.mobile,
				province: tradeOrderReceiver.state,
				city: tradeOrderReceiver.city,
				district: tradeOrderReceiver.district,
				town: tradeOrderReceiver.town,
				address: addressInfo.address,
				country: tradeOrderReceiver.country,
				zipCode: tradeOrderReceiver.zip,
			};
		},

		/**
		 * 将oms商品列表和原始商品匹配
		 * @param {*} omsTradeInfo 
		 * @param {*} originalTradeGoodsList 
		 */
		_matchOriginalTradeGoodsList(omsTradeInfo, originalTradeGoodsList) {
			// 遍历销售单货品列表，生成退款货品列表（和网店信息通过subTradeId关联）
			let newTradeOrderGoodsArr = [];
			let goodsScoreTotal = 0; // 记录商品购买使用积分总和
			let deductionScoreTotal = 0; // 记录积分抵扣使用积分总和
			// 记录累加过程中所有积分项的最大小数位数（包含 sellScore、singleGoodsDeductionScore、sellCount）
			let maxScoreDigit = 0;
			omsTradeInfo.tradeOrderGoodsArr.forEach(omsTradeGoods => {
				// 用于标记是否匹配到原始单商品
				let isMatchedGoods = false;
				// 筛选出退款货品关联的原始单货品数据
				let curSourceGoodsList = originalTradeGoodsList.filter(sourceGoods => sourceGoods.tradeNo == omsTradeGoods.sourceTradeNo &&
					sourceGoods.goodsId == omsTradeGoods.goodsId && sourceGoods.specId == omsTradeGoods.specId && sourceGoods.unit == omsTradeGoods.unit);
				// 标记是否匹配到货品，没有匹配到则按照子单号匹配（不能一开始就用子单号，否则无法区分OMS改单情况，OMS改单后展示数据仍需用销售单的）
				if (curSourceGoodsList.length > 0) {
					isMatchedGoods = true;
				}
				// 仅匹配非组合装情况（组合装子件修改后就无法按照原品比例匹配，所以此处先不处理组合装）
				else if (!omsTradeGoods.fitSubTradeId) {
					curSourceGoodsList = originalTradeGoodsList.filter(sourceGoods => sourceGoods.subTradeNo == omsTradeGoods.sourceSubTradeNo);
				}

				// 补一条当前不在原始单情况的补齐数据
				curSourceGoodsList.push({
					goodsId: omsTradeGoods.goodsId,
					specId: omsTradeGoods.skuId,
					unit: omsTradeGoods.unit,
					tradeId: 0,
					tradeNo: "",
					sellScore: 0,
					sellCount: 99999999,
					singleGoodsDeductionScore: 0
				});

				// 剩余待退货品数量
				omsTradeGoods.remainingCount = omsTradeGoods.sellCount;

				// 将退款货品分配到原始单上（原始单没有的则不需要处理）
				curSourceGoodsList.forEach(sourceGoods => {
					if (omsTradeGoods.remainingCount > 0) {
						// 计算退货数量
						let sellCount = 0;
						if (omsTradeGoods.remainingCount <= sourceGoods.sellCount) {
							sellCount = omsTradeGoods.remainingCount;
							omsTradeGoods.remainingCount = 0;
						} else {
							sellCount = sourceGoods.sellCount;
							omsTradeGoods.remainingCount -= sourceGoods.sellCount;
						}
						// 补充原始商品上的下单信息
						if (isMatchedGoods) {
							omsTradeGoods.sourcePicUrl = sourceGoods.picUrl;
							omsTradeGoods.specName = omsTradeGoods.skuName = sourceGoods.specName || omsTradeGoods.skuName;
							omsTradeGoods.goodsName = sourceGoods.goodsName || omsTradeGoods.goodsName;
							omsTradeGoods.goodsNo = sourceGoods.goodsNo || omsTradeGoods.goodsNo;
							omsTradeGoods.packageGoodsId = sourceGoods.packageGoodsId;
							omsTradeGoods.packageSpecId = sourceGoods.packageSpecId;
							omsTradeGoods.actType = sourceGoods.actType;
							omsTradeGoods.actId = sourceGoods.actId;
						}

					// 复制当前OMS货品信息
					let newOrderGoodsItem = JSON.parse(JSON.stringify(omsTradeGoods));

					// 重新计算当前商品所用积分
					newOrderGoodsItem.sellPoint = sourceGoods.sellScore; // 单个商品购买所需积分
					newOrderGoodsItem.sellCount = sellCount;

					// 统计积分总和（按原值累加，浮点误差由最终 maxScoreDigit 统一处理）
					goodsScoreTotal += newOrderGoodsItem.sellPoint * sellCount;
					deductionScoreTotal += sourceGoods.singleGoodsDeductionScore * sellCount;

					// 收集所有参与累加的数值的小数位数，取最大值用于最终结果处理
					// 需考虑 sellScore、singleGoodsDeductionScore、sellCount 三者的小数位（商品数量可能为小数，如斤/克等单位）
					let curMaxDigit = Math.max(
						commonUtils.getDecimalDigit(newOrderGoodsItem.sellPoint),
						commonUtils.getDecimalDigit(sourceGoods.singleGoodsDeductionScore || 0),
						commonUtils.getDecimalDigit(sellCount)
					);
					if (curMaxDigit > maxScoreDigit) {
						maxScoreDigit = curMaxDigit;
					}

					// 生成退货货品
					newTradeOrderGoodsArr.push(newOrderGoodsItem);
				}
			});
		});

		// 累加完成后，按收集到的最大小数位数统一处理浮点误差（积分最终小数位由所有项中最多的小数位决定）
		if (maxScoreDigit > 0) {
			goodsScoreTotal = commonUtils.floatKeepDigit(goodsScoreTotal, maxScoreDigit);
			deductionScoreTotal = commonUtils.floatKeepDigit(deductionScoreTotal, maxScoreDigit);
		}

		// 记录积分总和
		omsTradeInfo.tradeOrder.goodsScoreTotal = goodsScoreTotal;
		omsTradeInfo.tradeOrder.deductionScoreTotal = parseInt(deductionScoreTotal.toFixed(0));
		omsTradeInfo.tradeOrder.pointTotal = goodsScoreTotal + omsTradeInfo.tradeOrder.deductionScoreTotal;

			omsTradeInfo.newTradeOrderGoodsArr = newTradeOrderGoodsArr;
		},

		/**
		 * 根据吉客云订单状态，生成允许退款/退货的类型（0 不可退，1 可退款，2 可退货）
		 * @param {*} tradeStatus 
		 */
		async __getCanRefundTypeByJackyunTradeStatus({
			tradeStatus,
			sysFlagIds = "",
			tradeFrom = ""
		}) {
			// 需要隐藏退款按钮的吉客云系统标记：10-虚拟发货、
			let omsTradeSysFlagIdListForHideRefundBtn = ["10"];
			// 配置参数准备
			let paramList = await getParam("canRefundStatusSelect,canReturnTradeStatus,canRefundForVirtualShippingTrade,isOpenOrderBackAttachments,OrderBackAttachmentsRemind");
			let canRefundStatusSelect = paramList.canRefundStatusSelect || "3";
			// 可以退货的订单状态，默认仅“已完成”可退货
			let canReturnTradeStatus = paramList.canReturnTradeStatus || "9090";
			// “虚拟发货”订单是否允许退款，默认不允许
			if (paramList.canRefundForVirtualShippingTrade == "1") {
				// 从需要隐藏退款按钮的标签中，把“虚拟发货”去掉
				omsTradeSysFlagIdListForHideRefundBtn = omsTradeSysFlagIdListForHideRefundBtn.filter(t => t != "10");
			}
			this.isOpenOrderBackAttachments = paramList.isOpenOrderBackAttachments == "1"; // 是否开启附件必传
			this.OrderBackAttachmentsRemind = paramList.OrderBackAttachmentsRemind||'退货附件'; // 附件字段
			// 检测oms订单系统标记，存在指定标记的订单则不可退款/退货
			let sysFlagIdList = (sysFlagIds || "").split(',');
			let notAllowedFlagId = sysFlagIdList.find(flagId => omsTradeSysFlagIdListForHideRefundBtn.includes(flagId));
			if (notAllowedFlagId) {
				return 0;
			}

			// 非吉商城订单 不可退款/退货
			if (![4, 11].includes(tradeFrom)) {
				return 0;
			}

			// 仅“已完成”可退货
			if ([9090].includes(tradeStatus)) {
				return 2;
			}

			// 预售未付尾款单子不允许退款
			if ([1030, 5010, 5020, 5030].includes(tradeStatus)) {
				return 0;
			}

			// 可以退货的订单状态，默认仅“已完成”可退货（发货在途订单允许退货，仅小程序要求）
			// let canReturnTradeStatusList = canReturnTradeStatus.split(",");
			// if (canReturnTradeStatusList.includes(tradeStatus.toString())) {
			// 	return 2;
			// }

			let canRefundPaymentStatusOfParam = canRefundStatusSelect;
			// 重新排序 后台设置可能是 "3,1,2"
			canRefundPaymentStatusOfParam = canRefundPaymentStatusOfParam.split(",").sort((a, b) => a - b).join(",");

			let refundPaymentStatus = [];
			switch (canRefundPaymentStatusOfParam) {
				// 待审核
				case "1":
					refundPaymentStatus = [1010];
					break;
				// 待复核
				case "2":
					refundPaymentStatus = [1050];
					break;
				case "1,2":
					refundPaymentStatus = [1010, 1050];
					break;
				// 除发货在途、已完成外的状态
				case "3":
				case "1,2,3":
				case "1,3":
				case "2,3":
					refundPaymentStatus = [6000, 9090];
					break;
				// 不允许发起退款
				case "4":
					refundPaymentStatus = [];
					break;
				default:
					refundPaymentStatus = [];
			}

			if (canRefundPaymentStatusOfParam == "4" || (canRefundPaymentStatusOfParam.includes("3") ? refundPaymentStatus.includes(tradeStatus) : !refundPaymentStatus.includes(tradeStatus))) {
				return 0;
			}

			// 剩余状态均允许退款
			return 1;
		},

		// 获取配置
		async _getParams() {
			// 获取用户信息
			this.customer = await getCustomerInfo();

			// 接收路由参数
			this.tradeNo = this.$route.query.no;

			// 接收配置参数
			let paramList = await getParam("isOpenCannotReturnTime,cannotReturnDays,channelAnotherNameList,isShowSingleSpec,isAllowEditTradeAddress,isShowGoodsNo,decimalDigits");
			this.config.isShowSingleSpec = paramList.isShowSingleSpec == "1";
			this.config.isOpenCannotReturnTime = paramList.isOpenCannotReturnTime != "0";
			this.config.cannotReturnDays = parseInt(paramList.cannotReturnDays || "14");
			this.config.channelAnotherNameList = paramList.channelAnotherNameList && JSON.parse(paramList.channelAnotherNameList) || [];
			this.config.isAllowEditTradeAddress = paramList.isAllowEditTradeAddress == "1";
			this.config.isShowGoodsNo = paramList.isShowGoodsNo == "1";
			this.decimalDigits = parseInt(paramList.decimalDigits) || 0;
		},
		//获取吉客云物流方式
		async getLogisticsWays() {
			let that = this;
			let paramList = await getParam("bindRefundLogisticList,bindLogisticList");
			var bindRefundLogisticList = !!paramList.bindRefundLogisticList ? JSON.parse(paramList
				.bindRefundLogisticList) : JSON.parse(paramList.bindLogisticList);
			if (bindRefundLogisticList && bindRefundLogisticList.length > 0) {
				var logisticsWays = [];

				bindRefundLogisticList.forEach((item) => {
					let arrLogi = item.split(',');

					logisticsWays.push({
						logisticName: arrLogi.length > 2 ? arrLogi[2] : arrLogi[0],
						logisticId: arrLogi[1]
					});
				});
				that.logisticsWays = logisticsWays;
				that.refundLogistics.logisticName = logisticsWays[0].logisticName;
				that.refundLogistics.logisticId = logisticsWays[0].logisticId;
			}

		},

		onCopySuccess() {
			this.$message({
				message: "复制成功",
				type: 'success'
			});
		},
		onCopyError(e) {
			this.$message.error({
				message: "复制失败"
			});
		},
		goBack() {
			commonUtils.backPage();
		},
		displayTrajectory() {
			this.trajectoryShow = true;
		},

		// differ解密
		decryptDiffer(mobile) {
			let that = this;

			return new Promise(function (resolve, reject) {
				if (!that.checkIsLock(mobile)) {
					resolve(mobile);
					return;
				}
				var items = [];
				items = that.initdecryptJson(items, "phone", mobile);
				var sensitiveOrders = {
					"items": items
				};
				var obj = {
					"encryptModel": "DIFFER"
				};
				obj["sensitiveOrders"] = sensitiveOrders;
				that.$request.jackyunPost({
					method: "trade.decryptdata",
					jsonStr: JSON.stringify(obj)
				}, function (data) {
					if (data.code == 200 && data.result.data.isSuccess == 1) {
						var sensitiveOrders = data.result.data.sensitiveOrders;
						if (sensitiveOrders[0].items[0].isSuccess == 1) {
							resolve(sensitiveOrders[0].items[0].decryptStr);
						}
					}
					resolve(mobile);
				});
			});
		},
		// 校验是否加锁
		checkIsLock(content) {
			let that = this;
			var reg = /.*~\/(\S*)\/~1~~/;
			if (!reg.test(content)) {
				return false;
			}
			return true;
		},

		/**
		 * 解密参数
		 * @param {*} items 
		 * @param {*} type 
		 * @param {*} content 
		 */
		initdecryptJson(items, type, content) {
			var reg = /.*~\/(\S*)\/~1~~/;
			if (reg.test(content)) {
				let plat = content.match(reg)[1];
				if (plat == "differ") {
					var decryContent = {};
					decryContent["type"] = type;
					decryContent["encryptStr"] = content;
					items.push(decryContent);
				}
			}
			return items;
		},

		// 获取吉客云物流信息(非别名)
		async __getLogisticByLogisticId(logisticId, logisticName) {
			if (logisticId == 0) {
				this.logisticName = logisticName;
				return;
			}

			let res = await callFeign("erp.logistic.getbyid", {
				id: logisticId
			});
			if (res.code == 200 && !!res.result.data) {
				logisticName = res.result.data.expressCode || "";
			}
			this.logisticName = logisticName;
		},

		/**
		 * 加载退款单状态
		 * @param {*} tradeNo 
		 */
		async _loadSellbackInfo() {
			// 获取退款单状态
			let sellbackInfoList = await refundApi.getRefundStatusByJackyunTradeNo([this.tradeNo]);

			// 处理当前订单的退款状态信息
			let sellbackInfo = this.__processingTradeRefundStatus(sellbackInfoList);

			this.sellbackInfo = sellbackInfo;
		},

		/**
		 * 订单退款单状态处理（一个订单可能对应多个退款单）
		 * @param {*} refundStatusList 
		 * @param {*} tradeInfo 
		 */
		__processingTradeRefundStatus(refundStatusList, trade = {}) {
			/**
			 * 退款状态（0待审核，1驳回，2审核通过）
			 * 退款类型（0退款，1退货）
			 */

			// 根据退款状态去重，多个相同状态的退款单做同样的状态处理
			refundStatusList = commonUtils.distinctArr(refundStatusList, "sellbackStatus");
			if (!refundStatusList || refundStatusList.length <= 0) {
				trade.sellbackStatus = -1;
				trade.sellbackType = -1;
				trade.sellbackStatusExplain = "";
				return trade;
			}

			// 当前订单退款状态，单一有效的状态数据
			let curTradeRefundInfo;
			if (refundStatusList.length == 1) {
				curTradeRefundInfo = refundStatusList[0];
			} else {
				// 去除“驳回”状态的单据，以当前生效的退款单为准
				let refundStatusNotRejectList = refundStatusList.filter(t => t.sellbackStatus != 1);
				if (refundStatusNotRejectList && refundStatusNotRejectList.length == 1) {
					curTradeRefundInfo = refundStatusNotRejectList[0];
				}
			}

			// 没有单一可判断的退款单状态，存在多条退款单状态的情况，显示“退款”或者“退货”
			if (!curTradeRefundInfo) {
				trade.sellbackStatus = refundStatusList[0].sellbackStatus;
				trade.sellbackType = refundStatusList[0].sellbackType;
				trade.sellbackStatusExplain = refundStatusList[0].sellbackType == 2 ? "退货" : "退款";
				return trade;
			}

			// 退款状态（0待审核，1驳回，2同意）
			trade.sellbackStatus = curTradeRefundInfo.sellbackStatus;
			// 退款类型（1退款，2退货）
			trade.sellbackType = curTradeRefundInfo.sellbackType;
			// 退款状态说明
			if (trade.sellbackType == 1 && trade.sellbackStatus == 0) {
				trade.sellbackStatusExplain = "待商家同意退款";
			} else if (trade.sellbackType == 1 && trade.sellbackStatus == 1) {
				trade.sellbackStatusExplain = "商家拒绝退款";
			} else if (trade.sellbackType == 1 && trade.sellbackStatus == 2) {
				trade.sellbackStatusExplain = "退款成功";
			} else if (trade.sellbackType == 2 && trade.sellbackStatus == 0) {
				trade.sellbackStatusExplain = "待商家同意退货";
			} else if (trade.sellbackType == 2 && trade.sellbackStatus == 1) {
				trade.sellbackStatusExplain = "商家拒绝退货";
			} else if (trade.sellbackType == 2 && trade.sellbackStatus == 2) {
				trade.sellbackStatusExplain = "退货成功";
			} else {
				trade.sellbackStatusExplain = "退款/退货";
			}
			return trade;
		},

		/**
		 * 申请退款按钮点击
		 */
		async showRefundDialog() {
			if (this.hasEleTicket) return this.$message('电子票相关订单暂不支持退款');
			if (this.ticketIds.length) {
				const result = await refundApi.getCouponCanrefund(this.ticketIds);
				if (result.length) return this.$message("电子票相关订单暂不支持退款");
			}
			// 订单状态为“已取消-被拆分”/“已取消-被合并”，提示
			if ([5020, 5030].includes(this.tradeDetail.tradeStatus)) {
				return this.$message.error({
					message: '请根据原始单号查找被合并/拆分后的子单申请退款'
				});
			}
			if ([5010].includes(this.tradeDetail.tradeStatus)) {
				return this.$message.error({
					message: '已取消的订单不允许申请退款，请联系商家手动退款'
				});
			}
			
			// 上膳源订单  如果被拆分或合并 不支持退款退货
			let sysFlagIdList = (this.omsTradeInfo.tradeOrder.sysFlagIds || "").split(',');
			if (this.hasSsyTrade && (sysFlagIdList.includes("3") || this.omsTradeInfo.sourceTradeNo.includes(','))) {
			    return this.$message.error({
					message: '"该订单已使用上膳源支付，暂不支持拆单/合单后进行退款'
				});
			}
			
			this.dialogVisible = true;
		},

		/**
		 * 申请退款
		 */
		refundBtn: _.debounce(function () {
			let loading;
			this.$confirm('确定退款?', '提示').then(async () => {
				// 显示“提交中”弹窗
				loading = this.$loading({
					text: '提交中',

				});

				// 获取检测oms订单详情
				let omsTradeInfo = await this._getGetAndCheckOmsTradeInfo(1);
				console.log(omsTradeInfo);
				// 未获取到订单信息则关闭退款弹窗（提示窗在检测中已有）
				if (!omsTradeInfo) {
					// 关闭退款弹窗
					this.dialogVisible = true;
					// 关闭“提交中”弹窗
					loading.close();
					return;
				}

				// 获取原始单列表
				let originalTradeList = await this._getOriginalTradeList(omsTradeInfo.sourceTradeNo);

				// 生成原始单货品列表（多个订单的货品合并到一起，并附加一些订单信息到商品上）
				let originalTradeGoodsList = this._getOriginalTradeGoodsList(originalTradeList);

				// 补充组合装相关扩展信息
				await this._suppFitGoodsExtendedInfo(omsTradeInfo, omsTradeInfo.tradeOrderGoodsArr);

				// 生成退款商品列表
				let sellbackGoodsList = this._getSellBackGoodsList(omsTradeInfo.tradeOrderGoodsArr, originalTradeGoodsList, omsTradeInfo.tradeOrderGoodsRelateOnlineArr, 1);

				// 获取卡券使用明细
				let couponUseDetail = await tradeApi.getCouponUseDetail(omsTradeInfo.sourceTradeNo.split(","));
				// 给卡券使用明细中添加原始单子单号数据（后续匹配需要用到）
				this._suppSubTradeNoForCouponUseDetail(couponUseDetail, originalTradeList);

				// 生成卡券返还信息（用作自动审核）
				//this.returnCardTicketInfoList = this._getReturnCardTicketInfoListNew(sellbackGoodsList, omsTradeInfo, originalTradeGoodsList, originalTradeList, couponUseDetail);
				if (!couponUseDetail || couponUseDetail.length == 0) {
					this.returnCardTicketInfoList = this._getReturnCardTicketInfoList(sellbackGoodsList);
				} else {
					this.returnCardTicketInfoList = this._getReturnCardTicketInfoListNew(sellbackGoodsList, omsTradeInfo, originalTradeGoodsList, originalTradeList, couponUseDetail);
				}

				// 获取退款所需额外数据（金额合计、积分合计、卡券合计等）
				let extendedInfo = this._getSellbackExtendedInfo(originalTradeList, sellbackGoodsList, omsTradeInfo);

				// 组合装拆成单件退款情况兼容
				await this._packageGoodsRefundDataHandling(omsTradeInfo, originalTradeList, originalTradeGoodsList, this.returnCardTicketInfoList, extendedInfo, true, couponUseDetail);

				// 获取客户信息
				let customerInfo = await getCustomerInfo();

				// 是否为国补订单（存在国补单就按国补算）
				let isGovSubsidizedTrade = !!originalTradeList.find(t => t.isGovSubsidized == 1);

				// 退款单信息
				let sellBackInfo = {
					sellbackType: 1, // 退货类型（1退款 2退货）
					tradeNo: omsTradeInfo.sourceTradeNo, // 原关联订单号（多个）
					jackyunTradeId: omsTradeInfo.tradeId, // 吉客云订单ID
					jackyunTradeNo: omsTradeInfo.tradeNo, // 吉客云订单号
					customerId: customerInfo.customerId, // 客户id
					originalTotalAmount: extendedInfo.originalTotalAmount, // 原单总金额
					couponDeductAmount: extendedInfo.couponDeductAmount, // 卡券抵扣金额
					shouldRefundAmount: extendedInfo.shouldRefundAmount, // 应退金额
					shouldReturnScoreTotal: extendedInfo.shouldReturnScoreTotal, // 应退总积分
					sellbackCount: extendedInfo.allReturnGoodsCount, // 退货总数量
					shopId: omsTradeInfo.tradeOrder.shopId, // 渠道ID（吉客云订单）
					shopName: omsTradeInfo.tradeOrder.shopName, // 渠道名称（吉客云订单）
					accountId: originalTradeList[0].accountId, // 原单下单结算账户
					chargeType: omsTradeInfo.tradeOrder.chargeTypeExplain, // 结算方式（无效字段）
					currencyCode: omsTradeInfo.tradeOrder.chargeCurrencyCode, // 币种符号
					currencyName: omsTradeInfo.tradeOrder.chargeCurrency, // 币种名称
					payType: extendedInfo.payTypes, // 支付方式
					reason: this.refundForm.reson, // 	退换原因
					remark: this.refundForm.remark, // 退款备注
					sellBackGoodsList: sellbackGoodsList, // 退款商品信息
					returnCardTicketInfoList: this.returnCardTicketInfoList, // 返还卡券信息
					// 记录原始单信息，无实际作用，仅后台展示
					tradeNick: omsTradeInfo.tradeOrderCustomer.customerName,
					sendTo: omsTradeInfo.tradeOrderReceiver.receiverName,
					tel: omsTradeInfo.tradeOrderReceiver.mobile,
					country: omsTradeInfo.tradeOrderReceiver.country,
					province: omsTradeInfo.tradeOrderReceiver.state,
					city: omsTradeInfo.tradeOrderReceiver.city,
					town: omsTradeInfo.tradeOrderReceiver.district,
					address: omsTradeInfo.tradeOrderReceiver.address.replace('  ', ' '),
					orderVersion: 1,
					// 补充退换补发单需要的参数
					sendTime: omsTradeInfo.tradeOrder.consignTime || "", // 发货时间
					payTime: omsTradeInfo.tradeOrder.payTime || "", // 支付时间
					omsTradeStatus: omsTradeInfo.tradeOrder.tradeStatus, // 订单状态
					isGovSubsidized: isGovSubsidizedTrade, // 国补订单标记
				};

				// 创建退款单（提示功能在方法内部完成）
				let res = await refundApi.createSellbackOrder(sellBackInfo);
				if (!res) {
					// 关闭“提交中”弹窗
					loading && loading.close();
					return;
				}

				// 记录吉客云日志
				addJackyunLog('JMALL_REFUND', omsTradeInfo.tradeId, "创建退款申请");

				// 订单退款成功，返回订单列表
				this.__gotoTradeListPage();

				// 关闭退款弹窗
				this.dialogVisible = true;
				// 关闭“提交中”弹窗
				loading.close();
			}).catch((e) => {
				if (e == "cancel") {
					return;
				}
				this.$message.error("退款申请创建异常");
				// 关闭“提交中”弹窗
				loading && loading.close();
				console.log(e);
			});
		}),

		/**
		 * 获取并检测吉客云订单详情
		 * @param {*} refundType 
		 */
		async _getGetAndCheckOmsTradeInfo(refundType) {
			// 获取销售单详情
			let omsTradeInfo = await tradeApi.getOmsTradeDetail(this.tradeNo);
			if (!omsTradeInfo.tradeId) {
				this.$message.error("未检测到销售单信息，请刷新重试");
				this.__gotoTradeListPage();
				return null;
			}

			// 退款检测订单状态
			if (refundType != await this.__getCanRefundTypeByJackyunTradeStatus(omsTradeInfo.tradeOrder)) {
				this.$message.error("订单状态已变更");
				setTimeout(function () {
					// 刷新当前页面
					location.reload();
				}, 1200);
				return null;
			}

			// 订单信息解密
			await tradeApi.tradeDecrypt(omsTradeInfo);

			return omsTradeInfo;
		},

		/**
		 * 跳转到订单列表
		 */
		__gotoTradeListPage(time = 1200) {
			let _this = this;
			setTimeout(function () {
				_this.$router.push({
					name: 'tradelist',
					query: {}
				});
			}, time);
		},

		/**
		 * 获取原始单列表
		 * @param {*} sourceTradeNos 
		 */
		async _getOriginalTradeList(sourceTradeNos) {
			// 获取当前页面上已有的原始单列表
			let originalTradeList = this.originalTradeList || [];
			if (originalTradeList.length > 0) {
				return originalTradeList;
			}
			// 获取原始单列表
			originalTradeList = await tradeApi.getJmallTradeDetailList(sourceTradeNos);
			this.originalTradeList = originalTradeList || [];
			//console.log('originalTradeList',originalTradeList)
			return originalTradeList;
		},

		/**
		 * 获取原始单商品集合（并附加一些订单信息到商品上）
		 * @param {*} originalTradeList 
		 */
		_getOriginalTradeGoodsList(originalTradeList) {
			// 生成原始单货品列表（多个订单的货品合并到一起）
			let originalTradeGoodsList = [];
			// 遍历原始单，生成原始单货品，并前置计算退货所需数据
			originalTradeList.forEach(originalTrade => {
				// 生成原始单货品列表
				originalTrade.tradeGoodsList.forEach(tradeGoods => {
					tradeGoods.tradeId = originalTrade.tradeId;
					tradeGoods.tradeNo = originalTrade.tradeNo;
					tradeGoods.subTradeNo = `${originalTrade.tradeNo}_${tradeGoods.recId}`;
					tradeGoods.jackyunTradeId = originalTrade.jackyunTradeId;
					tradeGoods.jackyunTradeNo = originalTrade.jackyunTradeNo;
					tradeGoods.couponCode = originalTrade.couponCode; // 卡券编号
					tradeGoods.tradeCouponValue = originalTrade.couponTotal; // 订单上卡券抵扣金额
					tradeGoods.singleGoodsCouponDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.couponDeductionAmount / tradeGoods.sellCount, 4); // 卡券抵扣金额均摊
					tradeGoods.singleGoodsScoreDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.scoreDeductionAmount / tradeGoods.sellCount, 4); // 积分抵扣金额均摊
					tradeGoods.singleGoodsFavourableDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.favourableDeductionAmount / tradeGoods.sellCount, 4); // 改价优惠金额均摊
					tradeGoods.singleGoodsDiscountDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.discountDeductionAmount / tradeGoods.sellCount, 4); // 折扣优惠金额均摊
					tradeGoods.singleGoodsDeductionScore = commonUtils.floatKeepDigit(tradeGoods.sellPrice / originalTrade.goodsTotal * (originalTrade.deductionScore || 0), 4); // 积分抵扣的积分均摊到单个货品
					tradeGoods.shopId = originalTrade.shopId;
					tradeGoods.shopName = originalTrade.shopName;
				});
				originalTradeGoodsList = originalTradeGoodsList.concat(originalTrade.tradeGoodsList);
			});
			return originalTradeGoodsList;
		},

		/**
		 * 补充组合装相关扩展信息
		 */
		async _suppFitGoodsExtendedInfo(omsTradeInfo, needReturnGoodsList) {
			// 检测是否含有组合装，没有则直接返回
			let hasFitGoods = !!needReturnGoodsList.find(t => t.isFitGoods);
			if (!hasFitGoods) {
				return;
			}

			// 获取关联订单（不包含当前订单）
			let relateTradeList = await tradeApi.getOmsRelateTradeDetailList(omsTradeInfo.tradeId);

			// 将当前订单补充进去
			relateTradeList.push(omsTradeInfo);

			// 按组合装进行分组统计金额
			let fitGoodsSummaryArr = [];
			relateTradeList.forEach(trade => {
				trade.tradeOrderGoodsArr.forEach(goods => {
					if (goods.isFitGoods) {
						// 检测是否已经存在，存在则累加，不存在则新增
						let existFit = fitGoodsSummaryArr.find(t => t.fitSubTradeId == goods.fitSubTradeId);
						if (existFit) {
							existFit.totalAmount += (goods.sellTotal || 0);
						} else {
							fitGoodsSummaryArr.push({
								fitSubTradeId: goods.fitSubTradeId,
								totalAmount: goods.sellTotal || 0
							});
						}
					}
				});
			});

			// 计算退款货品的单个组合装子件所占比例
			needReturnGoodsList.forEach(goods => {
				if (goods.isFitGoods) {
					// 找到当前货品对应的组合装总金额
					let existFit = fitGoodsSummaryArr.find(t => t.fitSubTradeId == goods.fitSubTradeId);
					if (existFit) {
						goods.fitGoodsItemRatio = commonUtils.floatKeepDigit(goods.sellPrice / existFit.totalAmount, 6);
					} else {
						goods.fitGoodsItemRatio = 0;
					}
				}
			});
		},

		/**
		 * 生成退款货品列表
		 * @param {*} needReturnGoodsList 
		 * @param {*} originalTradeGoodsList 
		 * @param {*} tradeOrderGoodsRelateOnlineArr 
		 */
		_getSellBackGoodsList(needReturnGoodsList, originalTradeGoodsList, tradeOrderGoodsRelateOnlineArr, sellbackType) {
			let _this = this;
			// 遍历销售单货品列表，生成退款货品列表（和网店信息通过subTradeId关联）
			let sellbackGoodsList = [];
			needReturnGoodsList.forEach(returnGoods => {
				// 匹配页面渲染用的OMS订单详情（已经附加了原始单信息）
				let tmpGoods = _this.omsTradeInfo.newTradeOrderGoodsArr.find(t => t.id == returnGoods.id);
				if (tmpGoods) {
					returnGoods.goodsName = tmpGoods.goodsName;
					returnGoods.specName = tmpGoods.specName;
					returnGoods.picUrl = tmpGoods.sourcePicUrl;
				}

				// 筛选出退款货品关联的原始单货品数据
				let curSourceGoodsList = originalTradeGoodsList.filter(sourceGoods => sourceGoods.tradeNo == returnGoods.sourceTradeNo &&
					sourceGoods.goodsId == returnGoods.goodsId && sourceGoods.specId == returnGoods.specId && sourceGoods.unit == returnGoods.unit);
				// 没有匹配到则根据子单号匹配
				if (curSourceGoodsList.length <= 0) {
					curSourceGoodsList = originalTradeGoodsList.filter(sourceGoods => sourceGoods.subTradeNo == returnGoods.sourceSubTradeNo);
					// 如果是组合装，需要修改数量以确保所有的子商品都能匹配到，并且是以子件形式退的，标记为非组合装，否则退换补发单创建会异常
					if (curSourceGoodsList.length > 0 && returnGoods.isFitGoods) {
						curSourceGoodsList[0].sellCount = 99999999;
						curSourceGoodsList[0].isPackage = 0;
					}
				}

				// 补一条当前不在原始单情况的补齐数据
				curSourceGoodsList.push({
					goodsId: returnGoods.goodsId,
					specId: returnGoods.skuId,
					unit: returnGoods.unit,
					tradeId: 0,
					tradeNo: "",
					sellScore: 0,
					sellCount: 99999999,
					singleGoodsDeductionScore: 0
				});

				// 剩余待退货品数量
				returnGoods.remainingRefundCount = sellbackType == 2 ? returnGoods.returnCount : returnGoods.sellCount;

				// 将退款货品分配到原始单上（原始单没有的则不需要处理）
				curSourceGoodsList.forEach(sourceGoods => {
					if (returnGoods.remainingRefundCount > 0) {
						// 计算退货数量
						let returnCount = 0;
						if (returnGoods.remainingRefundCount <= sourceGoods.sellCount) {
							returnCount = returnGoods.remainingRefundCount;
							returnGoods.remainingRefundCount = 0;
						} else {
							returnCount = sourceGoods.sellCount;
							returnGoods.remainingRefundCount -= sourceGoods.sellCount;
						}

						// 退款/退货商品单价（退款需要去除邮资）
						let sellPrice = sellbackType == 1 ? returnGoods.realSellPrice : (returnGoods.realSellPrice - returnGoods.sellPostage);
						// 组合装子件金额比例
						let fitGoodsItemRatio = returnGoods.isFitGoods ? (returnGoods.fitGoodsItemRatio || 0) : 1;
						// 原始单上的积分计算
						let sourceSellScore = (sourceGoods.sellScore || 0) * fitGoodsItemRatio;
						let sourceSingleGoodsDeductionScore = (sourceGoods.singleGoodsDeductionScore || 0) * fitGoodsItemRatio;

						// 生成退货货品
						sellbackGoodsList.push({
							goodsId: returnGoods.goodsId,
							specId: returnGoods.skuId,
							unit: returnGoods.unit,
							sellCount: returnCount,
							returnCount: returnCount,
							specName: returnGoods.specName,
							goodsName: sourceGoods.sourceGoodsName || returnGoods.goodsName,
							goodsNo: sourceGoods.sourceGoodsNo || returnGoods.goodsNo,
							sellPrice: sellPrice,
							sellTotal: sellPrice * returnCount,
							// sellScore: (sourceGoods.sellScore || 0) + Math.round(sourceGoods.singleGoodsDeductionScore),
							// scoreTotal: (sourceGoods.sellScore || 0) * returnCount + Math.round(sourceGoods.singleGoodsDeductionScore * returnCount),
							sellScore: Math.round(sourceSellScore + sourceSingleGoodsDeductionScore),
							scoreTotal: Math.round((sourceSellScore + sourceSingleGoodsDeductionScore) * returnCount),
							sourceTradeId: sourceGoods.tradeId || 0,
							sourceOrderNo: sourceGoods.tradeNo || "",
							jkySubTradeId: returnGoods.subTradeId,
							// 以下参数为内部传值使用，后端不要求
							couponCode: sourceGoods.couponCode || "",
							tradeCouponValue: sourceGoods.tradeCouponValue || 0,
							goodsCouponDeductionAmount: Math.min(sourceGoods.couponDeductionAmount || 0, commonUtils.floatKeepDigit((sourceGoods.singleGoodsCouponDeductionAmount || 0) * returnCount)),
							// goodsScoreDeductionAmount: Math.min(sourceGoods.scoreDeductionAmount || 0, commonUtils.floatKeepDigit((sourceGoods.singleGoodsScoreDeductionAmount || 0) * returnCount)),
							// goodsFavourableDeductionAmount: Math.min(sourceGoods.favourableDeductionAmount || 0, commonUtils.floatKeepDigit((sourceGoods.singleGoodsFavourableDeductionAmount || 0) * returnCount)),
							// goodsDiscountDeductionAmount: Math.min(sourceGoods.discountDeductionAmount || 0, commonUtils.floatKeepDigit((sourceGoods.singleGoodsDiscountDeductionAmount || 0) * returnCount)),
							// goodsDeductionScore: commonUtils.floatKeepDigit(sourceGoods.singleGoodsDeductionScore * returnCount, 4),
							scoreTotalExact: (sourceSellScore + sourceSingleGoodsDeductionScore) * returnCount, // 精确积分，用作汇总计算，所以此处不进行小数位处理
							jackyunTradeId: sourceGoods.jackyunTradeId || 0,
							jackyunTradeNo: sourceGoods.jackyunTradeNo || "",
							shopId: sourceGoods.shopId || 0,
							shopName: sourceGoods.shopName || "",
							sourceSellCount: sourceGoods.sellCount,
							fit: sourceGoods.isPackage == 1 ? 1 : 0,
							fitSubTradeId: returnGoods.fitSubTradeId,
							// oms相关金额字段，用作售后单生成
							omsSellPrice: returnGoods.sellPrice,
							omsDiscountFee: returnGoods.discountFee,
							omsSellTotal: returnGoods.sellTotal,
							omsSourceSellCount: returnGoods.sellCount,
            				remainingRefundCount: returnGoods.maxReturnCount - returnCount,
							omsGoodsFlagList: returnGoods.goodsIconList || [], // OMS货品标记
							fitGoodsItemRatio, // 组合装情况下子件所占比例
						});
					}
				});
			});

			// 所有商品售价
			let allSellTotal = commonUtils.sumArr(sellbackGoodsList, "sellTotal");

			// 遍历退款货品，补充原始单的sourceSubTradeNo
			sellbackGoodsList.forEach(goods => {
				// 子单号补充
				let onlineGoodsInfo = tradeOrderGoodsRelateOnlineArr.find(t => t.subTradeId == goods.jkySubTradeId);
				goods.sourceSubOrderNo = onlineGoodsInfo ? onlineGoodsInfo.sourceSubtradeNo : ""; // 仅后端保存用到，前端交互全用sourceSubTradeNo
				goods.sourceSubTradeNo = goods.sourceSubOrderNo;
				goods.returnTotal = sellbackType == 1 ? goods.sellTotal : commonUtils.floatKeepDigit(goods.sellTotal / allSellTotal * this.refundLogistics.sellBackApplyAmount);
			});

			return sellbackGoodsList;
		},

		/**
		 * 生成退卡数据
		 * @param {*} sellbackGoodsList 
		 */
		_getReturnCardTicketInfoList(sellbackGoodsList) {
			// 返还卡券信息（用作自动审核）
			let returnCardTicketInfoList = [];
			sellbackGoodsList.forEach(goods => {
				// 添加卡券返还信息
				if (goods.couponCode) {
					// 获取已经存在的卡券返还信息
					let returnCardInfo = returnCardTicketInfoList.find(t => t.returnOriginalNo == goods.sourceOrderNo && t.ticketCode == goods.couponCode);

					// 不存在则新增，存在则累加
					if (!returnCardInfo) {
						returnCardTicketInfoList.push({
							tradeId: goods.jackyunTradeId.toString(), // 吉客云订单Id
							tradeNo: goods.jackyunTradeNo, // 吉客云订单编号
							returnOriginalNo: goods.sourceOrderNo, // 吉商城原始单号
							ticketCode: goods.couponCode, // 卡券编号
							sourceFrom: "jmall", // 请求来源
							ticketCodeList: [{
								ticketCode: goods.couponCode, // 卡券编号
								deductCost: goods.goodsCouponDeductionAmount, // 卡券返还金额
								originalDeductCost: goods.tradeCouponValue, // 原始单上的抵扣金额
								returnOrderGoodList: [{
									goodsId: goods.goodsId.toString(),
									specId: goods.specId.toString(),
									unit: goods.unit,
									sellCount: goods.sellCount,
									goodsName: goods.goodsName,
									specName: goods.specName,
								}]
							}],
							returnTradeOrder: {
								tradeId: goods.jackyunTradeId.toString(), // 吉客云订单Id
								tradeNo: goods.jackyunTradeNo, // 吉客云订单编号
								shopId: goods.shopId.toString(), // 下单渠道Id
								shopName: goods.shopName, // 下单渠道名称
							}
						});
					} else {
						returnCardInfo.ticketCodeList[0].deductCost = commonUtils.floatKeepDigit(returnCardInfo.ticketCodeList[0].deductCost + goods.goodsCouponDeductionAmount);
						returnCardInfo.ticketCodeList[0].returnOrderGoodList.push({
							goodsId: goods.goodsId.toString(),
							specId: goods.specId.toString(),
							unit: goods.unit,
							sellCount: goods.sellCount,
							goodsName: goods.goodsName,
							specName: goods.specName,
						});
					}
				}
			});
			return returnCardTicketInfoList;
		},


		/**
		 * 生成退卡数据New
		 * @param {*} sellbackGoodsList
		 * @param {*} omsTradeInfo
		 * @param {*} originalTradeGoodsList
		 * @param {*} originalTradeList
		 * @param {*} couponUseDetail
		 * @param {*} isPackage
		 */
		_getReturnCardTicketInfoListNew(sellbackGoodsList, omsTradeInfo, originalTradeGoodsList, originalTradeList, couponUseDetail, isPackage = false) {
			// 接口需要的卡券数据
			let returnCardTicketInfoList = [];

			// 循环需要SpecIdList数据
			let goodsSpecIdListOfCouponUseDetail = commonUtils.mergeAndSumV2(couponUseDetail.map(item => {
				return {
					specId: item.specId,
					unit: item.unit
				}
			}), ['specId', 'unit']);

			// 非组合装情况根据sellbackGoodsList进行循环
			let tempList = !isPackage ? sellbackGoodsList : goodsSpecIdListOfCouponUseDetail;

			tempList.forEach(goods => {
				if (!isPackage && !goods.couponCode) {
					return;
				}
				if (isPackage) {
					// 是组合装的话需要补充数据
					goods = originalTradeGoodsList.find(originalGoods => originalGoods.specId == goods.specId && originalGoods.unit == goods.unit);
					goods.jackyunTradeId = originalTradeList[0].jackyunTradeId.toString();
					goods.jackyunTradeNo = originalTradeList[0].jackyunTradeNo;
					goods.shopId = originalTradeList[0].shopId.toString();
					goods.shopName = originalTradeList[0].shopName;
					goods.sourceOrderNo = goods.tradeNo;
					goods.tradeCouponValue = couponUseDetail.reduce((accumulator, currentValue) => (accumulator || 0) / 1 + currentValue.deductionAmount / 1, 0);
				}

				let couponMatchList = couponUseDetail.filter(item => item.specId == goods.specId && item.unit == goods.unit);

				// 没有匹配到则根据子单号匹配，仅匹配非组合装情况（组合装子件修改后就无法按照原品比例匹配，所以此处先不处理组合装）
				if (couponMatchList.length <= 0) {
					couponMatchList = couponUseDetail.filter(coupon => coupon.subTradeNo == goods.sourceSubTradeNo);
				}

				couponMatchList.forEach(couponUseItem => {
					// 获取已经存在的卡券返还信息
					let returnCardInfo = returnCardTicketInfoList.find(t => t.returnOriginalNo == goods.sourceOrderNo && t.ticketCode == couponUseItem.ticketCode);

					// 计算当前卡券抵扣金额，需要区分组合装子件情况
					let currDeductCost = 0;
					if (goods.fitGoodsItemRatio < 1) {
						currDeductCost = couponUseItem.deductionAmount * goods.fitGoodsItemRatio * goods.sellCount;
					} else {
						currDeductCost = couponUseItem.deductionAmount * (goods.sellCount / (goods.sourceSellCount || goods.sellCount));
					}

					// 不存在则新增，存在则累加
					if (!returnCardInfo) {
						returnCardTicketInfoList.push({
							tradeId: goods.jackyunTradeId.toString(), // 吉客云订单Id
							tradeNo: goods.jackyunTradeNo, // 吉客云订单编号
							returnOriginalNo: couponUseItem.tradeNo, // 吉商城原始单号
							ticketCode: couponUseItem.ticketCode, // 卡券编号
							sourceFrom: "jmall", // 请求来源
							ticketCodeList: [{
								ticketCode: couponUseItem.ticketCode, // 卡券编号
								deductCost: commonUtils.roundToDecimal(currDeductCost, 7), // 卡券返还金额(需要按数量比例计算抵扣金额)
								originalDeductCost: goods.tradeCouponValue, // 原始单上的抵扣金额
								returnOrderGoodList: [{
									goodsId: goods.goodsId.toString(),
									specId: goods.specId.toString(),
									unit: goods.unit,
									sellCount: goods.sellCount,
									goodsName: goods.goodsName,
									specName: goods.specName,
								}],
							}],
							returnTradeOrder: {
								tradeId: goods.jackyunTradeId.toString(), // 吉客云订单Id
								tradeNo: goods.jackyunTradeNo, // 吉客云订单编号
								shopId: goods.shopId.toString(), // 下单渠道Id
								shopName: goods.shopName, // 下单渠道名称
							}
						});
					} else {
						returnCardInfo.ticketCodeList[0].deductCost = commonUtils.roundToDecimal(returnCardInfo.ticketCodeList[0].deductCost + currDeductCost, 7);
						returnCardInfo.ticketCodeList[0].returnOrderGoodList.push({
							goodsId: goods.goodsId.toString(),
							specId: goods.specId.toString(),
							unit: goods.unit,
							sellCount: goods.sellCount,
							goodsName: goods.goodsName,
							specName: goods.specName,
						});
					}
				});
			});
			
			// 七位小数分摊金额累加完之后 再处理取两位小数  降低精度误差影响=> 后台审核累加处理 的时候 再取两位小数
			// returnCardTicketInfoList.forEach(item => {
			//     item.ticketCodeList.forEach(ticketCodeItem => {
			// 		ticketCodeItem.deductCost = commonUtils.roundToDecimal(ticketCodeItem.deductCost, 2)
			//     })
			// })
				
			return returnCardTicketInfoList;
		},

		/**
		 * 获取退款所需额外数据（金额合计、积分合计、卡券合计等）
		 * @param {*} originalTradeList 
		 * @param {*} sellbackGoodsList 
		 * @param {*} omsTradeInfo 
		 */
		_getSellbackExtendedInfo(originalTradeList, sellbackGoodsList, omsTradeInfo) {
			// 原单总金额
			let originalTotalAmount = 0;
			// 原订单积分抵扣金额所使用积分
			let originalScoreDeductionTotal = 0;
			// 支付方式
			let payTypeList = [];
			// 遍历原始单，生成原始单货品，并前置计算退货所需数据
			originalTradeList.forEach(originalTrade => {
				// 计算原单总金额
				originalTotalAmount += originalTrade.rcvTotal || 0;
				// 计算原订单积分抵扣金额所使用积分
				originalScoreDeductionTotal += originalTrade.scoreDeductionTotal || 0;
				// 记录支付方式
				if (originalTrade.combinePayData && originalTrade.combinePayData.length > 0) {
					payTypeList = payTypeList.concat(originalTrade.combinePayData.map(t => t.payType));
				} else {
					payTypeList.push(originalTrade.chargeType);
				}
			});

			// 卡券抵扣金额
			let couponDeductAmount = 0;
			// 应退总积分
			let shouldReturnScoreTotal = 0;
			// 商品总数量
			let allReturnGoodsCount = 0;
			// 应退总金额
			let shouldRefundAmount = 0;
			// 遍历退款货品，补充原始单的sourceSubTradeNo，并计算退款单金额相关数据
			sellbackGoodsList.forEach(goods => {
				// 金额计算
				couponDeductAmount += goods.goodsCouponDeductionAmount;
				shouldReturnScoreTotal += goods.scoreTotalExact;
				allReturnGoodsCount += goods.returnCount;
				shouldRefundAmount += goods.returnTotal;
			});

			// 卡券返还金额校正
			couponDeductAmount = commonUtils.floatKeepDigit(couponDeductAmount);
			if (originalTradeList.length == 1) {
				if (Math.abs(couponDeductAmount - originalTradeList[0].couponTotal) < 0.02) {
					couponDeductAmount = originalTradeList[0].couponTotal;
				}
			}
			// 退款申请金额校正
			shouldRefundAmount = commonUtils.floatKeepDigit(shouldRefundAmount);
			if (shouldRefundAmount > omsTradeInfo.tradeOrder.payment ||
				(shouldRefundAmount > 0.02 && Math.abs(shouldRefundAmount - omsTradeInfo.tradeOrder.payment) < 0.02)) {
				shouldRefundAmount = omsTradeInfo.tradeOrder.payment;
			}

			return {
				originalTotalAmount: commonUtils.floatKeepDigit(originalTotalAmount),
				payTypes: commonUtils.distinctArr(payTypeList).join(","),
				couponDeductAmount,
				shouldReturnScoreTotal: Math.round(shouldReturnScoreTotal),
				allReturnGoodsCount: Math.round(allReturnGoodsCount),
				shouldRefundAmount,
			};
		},

		/**
		 * 处理组装下单情况数据
		 * @param {*} omsTradeInfo 
		 * @param {*} originalTradeList 
		 * @param {*} originalTradeGoodsList 
		 * @param {*} returnCardTicketInfoList 
		 * @param {*} refundExtendedInfo 
		 * @param {*} isReturnAllGoods 
		 */
		async _packageGoodsRefundDataHandling(omsTradeInfo, originalTradeList, originalTradeGoodsList, returnCardTicketInfoList, refundExtendedInfo, isReturnAllGoods, couponUseDetail) {
			// 订单如果有过拆合情况，则不需要处理
			// if (omsTradeInfo.sourceTradeNo.includes(",") || originalTradeList.length != 1) {
			// 	return;
			// }
			// if (originalTradeList[0].jackyunTradeNo != omsTradeInfo.tradeNo) {
			// 	return;
			// }
			if (originalTradeList.length != 1) {
				return;
			}

			// 如果不包含组合装，则不需要处理（仅组合装拆成单品的情况有问题）
			// let goodsIds = originalTradeGoodsList.map(t => t.goodsId).join(",");
			// if (!await goodsUtils.checkIsIncludesPackageGoods(goodsIds)) {
			// 	return;
			// }

			// 检测商品是否全退，不全退则不需要处理
			if (!isReturnAllGoods) {
				return;
			}
			
			// 判断是否为组合装商品，不是则不需要处理
			if (!(omsTradeInfo.tradeOrderGoodsArr || []).find(item => item && item.isFitGoods)) {
			    return;
			}

			// 获取原始单对应的有效订单数量，如果只有一条，则退还卡券（20240702产品提缺陷，统一按照剩余唯一有效单处理，其他组合拆分、组合装等情况不考虑）
			let validTradeCount = await tradeApi.getOmsTradeCountBySourceTradeNos(omsTradeInfo.sourceTradeNo, ['1010', '1020', '1030', '1050', '2000', '2010', '2020', '2030', '2040', '3010', '4110', '4111', '4112', '4113', '4121', '4122', '4123', '4130', '4040', '4041', '4042', '4050', '4051', '4052', '6000', '9090']);
			if (validTradeCount > 1) {
				return;
			}

			// 重新生成卡券信息（未拆合且是组合装下单的，需要返还全部卡券）->26.1.28 只有提货券需要进该逻辑 组合装抵扣券XQ202501140035已处理
			if (couponUseDetail.length > 0 && couponUseDetail[0].ticketType == 1) {
				this.returnCardTicketInfoList = this._getReturnCardTicketInfoListNew([], omsTradeInfo, originalTradeGoodsList, originalTradeList, couponUseDetail, true);
			}
			// 兼容 没有生成退卡使用明细数据的情况
			if ((!couponUseDetail || couponUseDetail.length == 0) && originalTradeList[0].couponCode) {
				this.returnCardTicketInfoList = [{
					tradeId: originalTradeList[0].jackyunTradeId.toString(), // 吉客云订单Id
					tradeNo: originalTradeList[0].jackyunTradeNo, // 吉客云订单编号
					returnOriginalNo: omsTradeInfo.sourceTradeNo, // 吉商城原始单号
					ticketCode: originalTradeList[0].couponCode, // 卡券编号
					sourceFrom: "jmall", // 请求来源
					ticketCodeList: [{
						ticketCode: originalTradeList[0].couponCode, // 卡券编号
						deductCost: originalTradeList[0].couponTotal, // 卡券返还金额
						originalDeductCost: originalTradeList[0].couponTotal, // 原始单上的抵扣金额
						returnOrderGoodList: originalTradeGoodsList.map(goods => {
							return {
								goodsId: goods.goodsId.toString(),
								specId: goods.specId.toString(),
								unit: goods.unit,
								sellCount: goods.sellCount,
								goodsName: goods.goodsName,
								specName: goods.specName,
							};
						})
					}],
					returnTradeOrder: {
						tradeId: originalTradeList[0].jackyunTradeId.toString(), // 吉客云订单Id
						tradeNo: originalTradeList[0].jackyunTradeNo, // 吉客云订单编号
						shopId: originalTradeList[0].shopId.toString(), // 下单渠道Id
						shopName: originalTradeList[0].shopName, // 下单渠道名称
					}
				}];
			}

			// 处理退款积分等扩展信息
			refundExtendedInfo.couponDeductAmount = originalTradeList[0].couponTotal; // 卡券抵扣金额
			refundExtendedInfo.shouldReturnScoreTotal = originalTradeList[0].scoreTotal + originalTradeList[0].deductionScore; // 应退总积分
		},

		/**
		 * 显示退货选货弹窗
		 */
		async showReturnGoodsDialog() {
			if (this.hasEleTicket) return this.$message("电子票相关订单暂不支持退货");
			if (this.ticketIds.length) {
				const result = await refundApi.getCouponCanrefund(this.ticketIds);
				if (result.length) return this.$message("电子票相关订单暂不支持退货");
			}
			
			// 上膳源订单  如果被拆分或合并 不支持退款退货
			let sysFlagIdList = (this.omsTradeInfo.tradeOrder.sysFlagIds || "").split(',');
			if (this.hasSsyTrade && (sysFlagIdList.includes("3") || this.omsTradeInfo.sourceTradeNo.includes(','))) {
			    return this.$message("该订单已使用上膳源支付，暂不支持拆单/合单后进行退货")
			}
			
			// 检测退货时限
			if (!await this.checkCanRefund()) {
				this.$message('已超出退货时限');
				return;
			}

			// 显示“提交中”弹窗
			let loading = this.$loading({
				text: '加载中',
			});

			// 获取检测oms订单详情
			let omsTradeInfo = await this._getGetAndCheckOmsTradeInfo(2);

			// 未获取到订单信息则关闭退款弹窗（提示窗在检测中已有）
			if (!omsTradeInfo) {
				// 关闭“提交中”弹窗
				loading.close();
				return;
			}

			// 过滤掉当前订单已经申请了退款的货品数据
			let goodsList = omsTradeInfo.tradeOrderGoodsArr;
			goodsList = await this._filterRefundedGoods(goodsList);

			// 过滤退换补发单商品
			goodsList = await this._filterReshipmentGoods(goodsList, this.tradeNo);

			if (!goodsList || goodsList.length <= 0) {
				this.$message.error("所有商品都已经申请退货");
				// 关闭“提交中”弹窗
				loading.close();
				return;
			}

			// 处理商品数据
			goodsList.forEach((item, index) => {
				// 匹配页面渲染用的OMS订单详情（已经附加了原始单信息）
				let tmpGoods = this.omsTradeInfo.newTradeOrderGoodsArr.find(t => t.id == item.id);
				if (tmpGoods) {
					item.goodsName = tmpGoods.goodsName;
					item.specName = tmpGoods.specName;
					item.picUrl = tmpGoods.picUrl;
				} else {
					try {
						let picInfo = JSON.parse(item.skuImgUrl);
						item.picUrl = picInfo.pic400x400;
					} catch (e) {
						item.picUrl = "";
					}
				}
				item.goodsIndex = index;
			});

			// 渲染可退货商品列表
			this.canReturnGoodsList = goodsList;

			// 显示选货弹窗
			loading.close();
			this.isShowReturnGoodsDialog = true;
			
			if(this.hasSsyTrade){
				this.isSelectAllReturnGoods = true;
				this.$nextTick(() => {
					this.selectAllReturnGoods()
				})
			}
		},

		/**
		 * 过滤掉当前订单已经申请了退款的货品数据
		 * @param {*} goodsList 
		 */
		async _filterRefundedGoods(goodsList) {
			// 获取当前订单已经申请退款的商品列表
			let refundGoodsList = await refundApi.getRefundedGoodsList(this.tradeNo);

			goodsList.forEach(goods => {
				// 获取已退商品
				let refundGoods = refundGoodsList.find(t => t.goodsId == goods.goodsId && t.specId == goods.skuId && t.unit == goods.unit);
				// 初始化最大可退数量以及选中状态等数据
				if (refundGoods && refundGoods.sellCount > 0) {
					// 已退货数量大于当前商品数量，则当前商品的已退数量就等于销售数量，已退货品数也做响应扣减（合并订单会有同品多行情况）
					if (refundGoods.sellCount > goods.sellCount) {
						goods.refundedCount = goods.sellCount;
						refundGoods.sellCount -= goods.sellCount;
					} else {
						goods.refundedCount = refundGoods.sellCount;
						refundGoods.sellCount = 0;
					}
				} else {
					goods.refundedCount = 0;
				}
				goods.maxReturnCount = goods.sellCount - goods.refundedCount;
				goods.returnCount = goods.maxReturnCount;
				goods.isSelected = false;
			});

			// 过滤掉不可退货的商品
			goodsList = goodsList.filter(t => t.maxReturnCount > 0);
			return goodsList;
		},

		/**
		 * 退货数量变更
		 * @param {Object} index
		 * @param {Object} value
		 */
		changeReturnCount(index, value) {
			// 修改退货数量
			this.canReturnGoodsList[index].returnCount = value;
			// 计算总数量
			this._calcSelectedGoodsCount();
		},

		/**
		 * 选中单个退货商品
		 * @param {Object} selectedGoodsList
		 */
		selectReturnGoods(selectedGoodsList) {
			// 记录选中数据
			let selectedIndexList = selectedGoodsList.map(t => t.goodsIndex);

			// 将可选商品列表中的商品置为选中
			this.canReturnGoodsList.forEach(t => {
				t.isSelected = selectedIndexList.includes(t.goodsIndex);
			});

			// 生成选中的退货商品列表
			this.selectedReturnGoodsList = this.canReturnGoodsList.filter(t => t.isSelected);

			// 计算总数量
			this._calcSelectedGoodsCount();
		},

		/**
		 * 计算选中货品中数量
		 */
		_calcSelectedGoodsCount() {
			let sumCount = 0;

			this.canReturnGoodsList.filter(t => t.isSelected).forEach(t => {
				if (t.isSelected) {
					sumCount += Number(t.returnCount);
				}
			});

			let maxReturnCount= commonUtils.sumArr(this.canReturnGoodsList, "maxReturnCount");

			// 同步变更"全选"状态（使用精度容差比较，避免浮点数精度问题）
			this.isSelectAllReturnGoods = Math.abs(sumCount - maxReturnCount) < 0.0001;

			this.sumCount = sumCount;
		},

		/**
		 * 退货商品全选
		 */
		selectAllReturnGoods() {
			// 所有商品都选中
			this.canReturnGoodsList.forEach(t => {
				t.isSelected = this.isSelectAllReturnGoods;
				t.returnCount = this.isSelectAllReturnGoods ? t.maxReturnCount : t.returnCount;
				console.log(this.isSelectAllReturnGoods)
			});

			// 生成选中的退货商品列表
			this.$refs.selectedReturnGoodsList.toggleAllSelection();
		},

		/**
		 * 校验是否能够退款
		 */
		async checkCanRefund() {
			try {
				// 未开启拦截则不限制
				if (!this.config.isOpenCannotReturnTime) {
					return true;
				}

				// 完成时间（没有完成时间的不做限制）
				let arriveTime = (this.tradeDetail && this.tradeDetail.arriveTime) || "";
				if (!arriveTime) {
					return true;
				}

				let arriveTimeStamp = new Date(arriveTime).getTime();
				let delayTime = this.config.cannotReturnDays * 60 * 24 * 60 * 1000;

				// 异常数据判断，异常数据统一不做限制
				if (isNaN(delayTime) || !(arriveTimeStamp > 0)) {
					return true;
				}

				let sysTime = await system.getSysTime();
				console.log(sysTime, "sysTime");
				return sysTime < arriveTimeStamp + delayTime;
			} catch (e) {
				return true;
			}
		},

		/**
		 * 展示退货主弹窗
		 */
		showReturnMainDialog() {
			// 获取选中的退款商品，并检测是存在数据
			this.selectedReturnGoodsList = this.canReturnGoodsList.filter(t => t.isSelected);
			if (!this.selectedReturnGoodsList || this.selectedReturnGoodsList.length <= 0) {
				this.$message.warning('请选择退货商品');
				return;
			}
			
			if (this.hasSsyTrade && (!this.isSelectAllReturnGoods || this.canReturnGoodsList.find(item=> item.returnCount < item.maxReturnCount))) {
				this.$message.warning('该订单已使用上膳源支付，不支持部分退货');
			    return;
			}

			// 关闭选货弹窗，显示退货主弹窗
			this.isShowReturnGoodsDialog = false;
			this.isShowReturnMainDialog = true;

			// 加载物流方式
			this.getLogisticsWays();

			// 计算最大可退额度
			let maxReturnAmount = 0;
			this.selectedReturnGoodsList.forEach(t => {
				maxReturnAmount += (t.realSellPrice - t.sellPostage) * t.returnCount;
			});

			// 渲染页面数据
			this.maxReturnAmount = commonUtils.floatKeepDigit(maxReturnAmount);
			this.returnPlaceHolder = `最大可退金额：${this.maxReturnAmount.toFixed(2)}`;
			this.refundLogistics.sellBackApplyAmount = this.maxReturnAmount.toFixed(2);
		},

		// 退货物流表单确认
		returnBtn: _.debounce(function () {
			// 参数校验
			if (!this.refundLogistics.sellBackApplyAmount && this.refundLogistics.sellBackApplyAmount != 0) {
				this.$message.warning("请输入退款金额");
				return;
			}
			if (isNaN(this.refundLogistics.sellBackApplyAmount)) {
				this.$message.warning("请输入正确的退款金额");
				return;
			}
			if (this.refundLogistics.sellBackApplyAmount > 0 && this.refundLogistics.sellBackApplyAmount > this.maxReturnAmount) {
				toast("最大可退金额为：" + this.maxReturnAmount.toFixed(2));
				return;
			}
			if (!this.refundLogistics.rcv_post_id && this.refundGoodsRules.postId[0].required) {
				this.$message.warning("请输入物流单号");
				return;
			}
			if (this.isOpenOrderBackAttachments && this.attachList.length == 0) {
				this.$message.error(this.OrderBackAttachmentsRemind);
				return;
			}
			let loading;
			this.$confirm('确定退货?', '提示').then(async () => {
				// 显示“提交中”弹窗
				loading = this.$loading({
					text: '提交中',
				});

				// 获取检测oms订单详情
				let omsTradeInfo = await this._getGetAndCheckOmsTradeInfo(2);
				console.log(omsTradeInfo);
				// 未获取到订单信息则关闭退款弹窗（提示窗在检测中已有）
				if (!omsTradeInfo) {
					// 关闭退款弹窗
					this.isShowReturnMainDialog = false;
					// 关闭“提交中”弹窗支付宝
					loading.close();
					return;
				}

				// 获取原始单列表
				let originalTradeList = await this._getOriginalTradeList(omsTradeInfo.sourceTradeNo);

				// 生成原始单货品列表（多个订单的货品合并到一起，并附加一些订单信息到商品上）
				let originalTradeGoodsList = this._getOriginalTradeGoodsList(originalTradeList);

				// 补充组合装相关扩展信息
				await this._suppFitGoodsExtendedInfo(omsTradeInfo, this.selectedReturnGoodsList);

				// 生成退款商品列表
				let sellbackGoodsList = this._getSellBackGoodsList(this.selectedReturnGoodsList, originalTradeGoodsList, omsTradeInfo.tradeOrderGoodsRelateOnlineArr, 2);

				// 获取卡券使用明细
				let couponUseDetail = await tradeApi.getCouponUseDetail(omsTradeInfo.sourceTradeNo.split(","));

				// 生成卡券返还信息（用作自动审核）
				// this.returnCardTicketInfoList = this._getReturnCardTicketInfoListNew(sellbackGoodsList, omsTradeInfo, originalTradeGoodsList, originalTradeList, couponUseDetail);
				if (!couponUseDetail || couponUseDetail.length == 0) {
					this.returnCardTicketInfoList = this._getReturnCardTicketInfoList(sellbackGoodsList);
				} else {
					this.returnCardTicketInfoList = this._getReturnCardTicketInfoListNew(sellbackGoodsList, omsTradeInfo, originalTradeGoodsList, originalTradeList, couponUseDetail);
				}

				// 获取退款所需额外数据（金额合计、积分合计、卡券合计等）
				let extendedInfo = this._getSellbackExtendedInfo(originalTradeList, sellbackGoodsList, omsTradeInfo);

				// 组合装拆成单件退款情况兼容
				await this._packageGoodsRefundDataHandling(omsTradeInfo, originalTradeList, originalTradeGoodsList, this.returnCardTicketInfoList, extendedInfo, this.isSelectAllReturnGoods, couponUseDetail);

				// 获取客户信息
				let customerInfo = await getCustomerInfo();
				// 是否为国补订单（存在国补单就按国补算）
				let isGovSubsidizedTrade = !!originalTradeList.find(t => t.isGovSubsidized == 1);

				// 退款单信息
				let sellBackInfo = {
					sellbackType: 2, // 退货类型（1退款 2退货）
					tradeNo: omsTradeInfo.sourceTradeNo, // 原关联订单号（多个）
					jackyunTradeId: omsTradeInfo.tradeId, // 吉客云订单ID
					jackyunTradeNo: omsTradeInfo.tradeNo, // 吉客云订单号
					customerId: customerInfo.customerId, // 客户id
					originalTotalAmount: extendedInfo.originalTotalAmount, // 原单总金额
					couponDeductAmount: extendedInfo.couponDeductAmount, // 卡券抵扣金额
					// shouldRefundAmount: extendedInfo.shouldRefundAmount, // 应退金额
					shouldRefundAmount: this.refundLogistics.sellBackApplyAmount, // 应退金额
					shouldReturnScoreTotal: extendedInfo.shouldReturnScoreTotal, // 应退总积分
					sellbackCount: extendedInfo.allReturnGoodsCount, // 退货总数量
					shopId: omsTradeInfo.tradeOrder.shopId, // 渠道ID（吉客云订单）
					shopName: omsTradeInfo.tradeOrder.shopName, // 渠道名称（吉客云订单）
					accountId: originalTradeList[0].accountId, // 原单下单结算账户
					chargeType: omsTradeInfo.tradeOrder.chargeTypeExplain, // 结算方式（无效字段）
					currencyCode: omsTradeInfo.tradeOrder.chargeCurrencyCode, // 币种符号
					currencyName: omsTradeInfo.tradeOrder.chargeCurrency, // 币种名称
					payType: extendedInfo.payTypes, // 支付方式
					sellerId: omsTradeInfo.tradeOrder.sellerId, // 业务员Id
					sellerName: omsTradeInfo.tradeOrder.seller, // 业务员名称
					logisticId: this.refundLogistics.logisticId, // 物流公司Id
					logisticName: this.refundLogistics.logisticName, // 物流公司名称
					rcvPostId: this.refundLogistics.rcv_post_id, // 物流单号
					reason: this.refundLogistics.reason, // 退换原因
					remark: this.refundLogistics.remark, // 退款备注
					sellBackGoodsList: sellbackGoodsList, // 退款商品信息
					returnCardTicketInfoList: this.returnCardTicketInfoList, // 返还卡券信息
					// 记录原始单信息，无实际作用，仅后台展示
					tradeNick: omsTradeInfo.tradeOrderCustomer.customerName,
					sendTo: omsTradeInfo.tradeOrderReceiver.receiverName,
					tel: omsTradeInfo.tradeOrderReceiver.mobile,
					country: omsTradeInfo.tradeOrderReceiver.country,
					province: omsTradeInfo.tradeOrderReceiver.state,
					city: omsTradeInfo.tradeOrderReceiver.city,
					town: omsTradeInfo.tradeOrderReceiver.district,
					address: omsTradeInfo.tradeOrderReceiver.address.replace('  ', ' '),
					isGovSubsidized: isGovSubsidizedTrade, // 国补订单标记
					omsTotalFee: omsTradeInfo.tradeOrder.totalFee, // oms订单货品总额
					omsReceivedPostFee: omsTradeInfo.tradeOrder.receivedPostFee, // oms订单邮费
					attachmentInfoList: this.attachList
				};
				console.log('sellBackInfo',sellBackInfo)
				// 创建退款单（提示功能在方法内部完成）
				let res = await refundApi.createSellbackOrder(sellBackInfo);
				if (!res) {
					this.__gotoTradeListPage();
					// 关闭“提交中”弹窗
					loading.close();
					return;
				}

				// 记录吉客云日志
				addJackyunLog('JMALL_REFUND', omsTradeInfo.tradeId, "创建退货申请");

				// 订单退款成功，返回订单列表
				this.__gotoTradeListPage();

				// 关闭退款弹窗
				this.isShowReturnMainDialog = false;
				// 关闭“提交中”弹窗
				loading.close();
			}).catch((e) => {
				this.$message.error("退货申请创建异常");
				// 关闭“提交中”弹窗
				loading.close();
				console.log(e);
			});
		}),

		closeEditDialog() {
			this.createEditDialog = false;
			this.showEditDialog = false;
		},

		async editSuccess(addressInfo) {
			// 获取规格
			let specIds = this.omsTradeInfo.tradeOrderGoodsArr.map(item => item.skuId);

			// 调用限购检测接口，获取检测结果（限购商品+有效商品）
			let res = addressInfo && await tradeApi.checkRestrictedGoods(addressInfo.province, addressInfo.city, addressInfo.district, specIds);

			// 如果校验不通过进行提示
			if (addressInfo && res.restrictedInfoList && res.restrictedInfoList.length > 0) {
				return this.$message.error(res.restrictedInfoList[0].limitSalesReminder);
			}

			// 更新订单详情数据
			this.currentAddr = {
				name: addressInfo.sendTo,
				tel: addressInfo.tel,
				province: addressInfo.province,
				city: addressInfo.city,
				district: addressInfo.district,
				town: addressInfo.town,
				address: addressInfo.address,
				country: addressInfo.country,
				// zipCode: addressInfo.zipCode,
			};

			// 修改订单
			await tradeApi.updateOmsTradeAddressInfo(this.tradeDetail.tradeNo, addressInfo);

			// 更新订单详情数据
			this.tradeReceiver.receiverName = addressInfo.sendTo;
			this.tradeReceiver.mobile = addressInfo.tel;
			this.tradeReceiver.province = addressInfo.province;
			this.tradeReceiver.city = addressInfo.city;
			this.tradeReceiver.district = addressInfo.district;
			this.tradeReceiver.address = addressInfo.address;
			this.tradeReceiver.country = addressInfo.country;

			this.$message.success("修改成功");
			this.closeEditDialog();
		},

		/**
		 * 展示地址修改弹窗
		 */
		openAddressEdit() {
			this.showEditDialog = true;
			this.createEditDialog = true;
		},

		/**
		 * 过滤退换补发商品
		 */
		async _filterReshipmentGoods(canReturnGoodsList, tradeNo) {
			// 获取当前订单 手动创建的退换补发单商品
			let reshipmentGoodsList = await refundApi.getReshipmentGoods(tradeNo);

			// 不存在 退换补发单商品 直接返回
			if (!(reshipmentGoodsList && reshipmentGoodsList.length > 0)) {
				return canReturnGoodsList;
			}

			// 扣减该销售单下关联的非商城来源的有效退换补发单商品数量
			canReturnGoodsList.forEach(item => {
				// 非商城来源的有效退换补发单商品
				let matchReshipmentGoodsList = reshipmentGoodsList.filter(reshipmentGoods => reshipmentGoods.goodsId == item.goodsId && item.specId == reshipmentGoods.specId && item.unit == reshipmentGoods.unit && ![113, '113'].includes(reshipmentGoods.source));

				// 处理最大可退数量
				matchReshipmentGoodsList.forEach(reshipmentGoods => {
					item.maxReturnCount = item.maxReturnCount - reshipmentGoods.returnCount;
					item.returnCount = item.maxReturnCount;
				});
			});

			return canReturnGoodsList.filter(t => t.maxReturnCount > 0);
		},

		/**
		 * 给卡券使用明细中添加原始单子单号数据（后续匹配需要用到）
		 * @param {*} couponUseDetail 
		 * @param {*} originalTradeList 
		 */
		_suppSubTradeNoForCouponUseDetail(couponUseDetail, originalTradeList) {
			// 遍历原始单，生成原始单货品，并前置计算退货所需数据
			originalTradeList.forEach(originalTrade => {
				originalTrade.tradeGoodsList.forEach(tradeGoods => {
					// 找到对应的商品
					couponUseDetail.filter(t => t.tradeNo == originalTrade.tradeNo && t.goodsId == tradeGoods.goodsId && t.specId == tradeGoods.specId && t.unit == tradeGoods.unit).forEach(item => {
					  item.subTradeNo = `${originalTrade.tradeNo}_${tradeGoods.recId}`;
					});
				});
			});
		},

		/**
		 * 获取退货地址
		 */
		async _getSellBackAddress() {
			let paramList = await getParam('isOpenShowSellBackAddress');

			// 订单数据
			let omsTradeOrderInfo = this.omsTradeInfo.tradeOrder;

			// 页面展示地址信息
			let sellBackAddressInfo = {};
			// 售后地址信息
			let sellerAddressInfo = {};
			// 发货仓库的地址信息
			let sellerWarehouseAddressInfo = {};

			// 匹配售后地址
			sellerAddressInfo = await refundApi.getSellBackAddress(omsTradeOrderInfo.shopId, omsTradeOrderInfo.warehouseId);

			// 售后地址匹配失败 需要匹配发货仓库的地址
			if (commonUtils.isEmptyObjectV2(sellerAddressInfo)) {
				sellerWarehouseAddressInfo = await refundApi.getSellerWarehouseAddress(omsTradeOrderInfo.warehouseId);
				//处理国家
				sellerWarehouseAddressInfo.countryName = sellerWarehouseAddressInfo.countryName == '中国' ? '' : sellerWarehouseAddressInfo.countryName;

				// 拼接省市区
				sellerWarehouseAddressInfo.address = `${sellerWarehouseAddressInfo.countryName}${sellerWarehouseAddressInfo.provinceName}${sellerWarehouseAddressInfo.cityName}${sellerWarehouseAddressInfo.townName}${sellerWarehouseAddressInfo.streetName}${sellerWarehouseAddressInfo.address}`;
			} else {
				// 拼接省市区
				sellerAddressInfo.address = `${sellerAddressInfo.country || ''}${sellerAddressInfo.province}${sellerAddressInfo.city}${sellerAddressInfo.area}${sellerAddressInfo.address}`;

			}

			// 展示数据赋值
			sellBackAddressInfo = {
				sellerName: sellerAddressInfo.name || sellerWarehouseAddressInfo.linkMan || '',
				sellerTel: sellerAddressInfo.mobile || sellerWarehouseAddressInfo.tel || '',
				sellerAddress: sellerAddressInfo.address || sellerWarehouseAddressInfo.address || ''
			};

			this.sellBackAddressInfo = sellBackAddressInfo;
			this.isOpenShowSellBackAddress = paramList.isOpenShowSellBackAddress == '1';
		},

		/**
		 * 获取退货地址
		 */
		async copySellBackAddress() {
			let sellBackAddressInfo = this.sellBackAddressInfo;

			let text = `${sellBackAddressInfo.sellerName}，${sellBackAddressInfo.sellerTel}，${sellBackAddressInfo.sellerAddress}`;

			// 创建一个临时的textarea元素
			let textarea = document.createElement('textarea');
			textarea.value = text;
			textarea.style.position = 'fixed'; // 避免滚动到页面底部
			document.body.appendChild(textarea);
			textarea.select();

			try {
				let successful = document.execCommand('copy');

				if (successful) {
					this.$message.success("复制成功");
				} else {
					this.$message.error("复制失败");
				}
			} catch (err) {
				this.$message.error("复制异常");
			}

			document.body.removeChild(textarea);
		},

		isImage(name) {
				const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp', '.ico', '.tiff', '.tif'];
				const fileExtension = name.substring(name.lastIndexOf('.')).toLowerCase();
				return imageExtensions.includes(fileExtension);
			},
			previewImg(url, index) {
				console.log('previewUrl', url)
				if (!url || url === 'undefined') {
					this.$message.warning('预览URL无效！')
					return;
				}
				
				this.previewIndex = index;
				this.newPreviewUrl = url;
				this.previewVisible = true;
				
				this.$nextTick(() => {
					this.$refs.imagePreview.showViewer = true
					
					// 创建并插入全局样式
					this.createGlobalStyle();
					
					// 初始应用样式
					setTimeout(this.applyImageStyles, 100);
					
					// 监听图片切换
					this.setupImageChangeWatcher();
				})
			},
			createGlobalStyle() {
				// 如果已经创建了样式，先移除
				if (this._styleElement) {
				this._styleElement.remove();
				}
				
				// 创建全局样式
				const style = document.createElement('style');
				style.innerHTML = `
				.el-image-viewer__img {
					max-width: 90vw !important;
					max-height: 90vh !important;
					width: auto !important;
					height: auto !important;
					object-fit: contain !important;
					transform-origin: center center !important;
				}
				`;
				document.head.appendChild(style);
				this._styleElement = style;
			},
			
			applyImageStyles() {
				const imgs = document.querySelectorAll('.el-image-viewer__img');
				imgs.forEach(img => {
				img.style.maxWidth = '90vw';
				img.style.maxHeight = '90vh';
				img.style.width = 'auto';
				img.style.height = 'auto';
				img.style.objectFit = 'contain';
				img.style.transformOrigin = 'center center';
				});
			},
			
			setupImageChangeWatcher() {
				// 清理之前的观察者
				if (this._imageObserver) {
				this._imageObserver.disconnect();
				}
				
				// 查找图片容器
				const viewer = document.querySelector('.el-image-viewer__wrapper');
				if (!viewer) return;
				
				// 创建观察者监听图片变化
				const observer = new MutationObserver(() => {
				this.applyImageStyles();
				});
				
				observer.observe(viewer, {
				childList: true,
				subtree: true
				});
				
				this._imageObserver = observer;
				
				// 清理
				this.$once('hook:beforeDestroy', () => {
				if (this._imageObserver) {
					this._imageObserver.disconnect();
				}
				if (this._styleElement) {
					this._styleElement.remove();
				}
				});
			},

			downloadFile(url,name) {
				console.log('downUrl', url)
				// 检查URL是否有效
				if (!url || url === 'undefined') {
					this.$message.warning('下载URL无效！')
					return;
				}
				fetch(url,{
						mode: 'cors',
						cache: 'no-store',
						credentials: 'same-origin'
					}
				)
				.then(response => {
					if (!response.ok) {
						throw new Error('网络响应不正常');
					}
					return response.blob();
				})
				.then(blob => {
					// 创建Blob URL
					const blobUrl = URL.createObjectURL(blob);
					const downloadLink = document.createElement('a');
					downloadLink.href = blobUrl;
					downloadLink.download = name || 'download';
					downloadLink.style.display = 'none';
					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);
					// 释放Blob URL
					URL.revokeObjectURL(blobUrl);
					//this.$message.success('下载成功')
				})
				.catch(error => {
					console.error('下载失败:', error);
					this.$message.warning('下载失败，请在图片上右键另存为');
					// 降级方案：在新窗口打开图片
					window.open(url, '_blank');
				});
				// const downloadLink = document.createElement('a');
				// downloadLink.href = url;
				// downloadLink.download = name || '文件下载'; // 设置下载的文件名
				// downloadLink.style.display = 'none';
				// // 添加到文档中
				// document.body.appendChild(downloadLink);
				// // 触发点击事件
				// downloadLink.click();
				// // 清理DOM
				// setTimeout(() => {
				// 	document.body.removeChild(downloadLink);
				// }, 100);
			}
	},
};
</script>

<style scoped="scoped">
	:deep(.el-image-viewer__wrapper img) {
  max-width: 90vw !important;
  max-height: 90vh !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain !important;
  transform-origin: center center !important;
}
.right-box {
	background-color: #fff;
	padding: 10px 30px 30px 30px !important;
	font-size: 18px;
}

.dialogClass .el-dialog__body {
	padding: 20px !important;
	padding-top: 0px !important;
	padding-bottom: 0px !important;
	margin-left: 20px !important;
}

.back-box {
	align-items: center;
	margin-left: -20px;
	height: 80px;
}

.back-btn {
	font-size: 42px;
	margin-right: 15px;
}

.status-box {
	height: 40px;
	background-color: #000;
	color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 24px 20px 24px 30px;
}

.trade-status {
	font-weight: bold;
	font-size: 21px;
}

.info-box {
	margin: 20px;
	border-bottom: 1px solid #dedede;
	font-size: 16px;
	min-height: 130px;
	position: relative;
}

.address-editbtn {
	position: absolute;
	right: 10px;
	bottom: 18px;
	text-align: center;
	font-size: 14px;
	border-radius: 3px;
	width: 60px;
	height: 25px;
	line-height: 25px;
	background-color: black;
	color: white;
	padding: 4px 10px;
	cursor: pointer;
}

.small-title {
	font-size: 16px;
	font-weight: 800;
}

.base-info {
	margin: 10px;
	line-height: 30px;
}

.base-item {
	color: #999;
	width: 80px;
	margin-right: 10px;
	display: inline-block;
	text-align: right;
	flex-shrink: 0;
}

.copy-btn {
	padding: 2px 10px;
	font-size: 13px;
	background-color: #F2F2F2;
	margin-left: 10px;
	color: #666;
	cursor: pointer;
}

.total-box {
	display: flex;
	justify-content: flex-end;
	border: none !important;
}

.total-box /deep/.el-form-item__label,
.total-box /deep/.el-form-item__content {
	font-size: 17px !important;
	color: #999 !important;
}

.total-box /deep/.el-form-item {
	margin-bottom: 0px !important;
}

.total {
	color: #000;
	font-size: 18px;
	font-weight: bold;
}

.money-text {
	color: #333;
	text-align: right;
	margin-left: 50px;
	line-height: 40px;
}

.score-text {
	position: relative;
	bottom: 1px;
	left: 5px;
	font-size: 15px;
}

.handle-box {
	margin-bottom: 60px;
	justify-content: flex-end;
}

.cancel-btn {
	color: #333;
	background-color: #F2F2F2;
}

.handle-btn {
	width: 140px;
	height: 60px;
	font-size: 16px;
	border: none;
	margin-left: 25px !important;
}

.log-btn {
	border: 1px solid #fff;
	border-radius: 6px;
	padding: 2px 6px;
	font-size: 15px;
	cursor: pointer;
	width: 100px;
	text-align: center;
}

.simple-info {
	margin-right: 20px;
	font-size: 16px;
	align-items: center;
	/* white-space: nowrap; */
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-all;
	max-width: 500px;
}

/deep/ .el-dialog .el-dialog__body {
	display: flex;
	align-items: center;
	margin: 0px !important;
}

.number {
	margin-top: 40px;
}


.info_footer {
	display: flex;
	display: -webkit-flex;
	line-height: 50px;
}

.allCheck {
	margin-left: 14.5px;
}

.span_footer {
	margin: 0 50px 0 50px;
}

.custom-top {
	height: 100rpx;
	font-size: 100rpx;
	text-align: center;
}

.tradeId-top {
	font-size: 80rpx;
	height: 100rpx;
	margin-top: 10px;
	margin-bottom: 5px;
}

.refund-button-div {
	text-align: right;
}

.el-select {
	width: 300px;
}

.el-select-dropdown__item {
	width: 200px !important;
}

.detailDialog /deep/ .el-dialog {
	overflow: hidden;
}

.dialogBox /deep/ .el-dialog__wrapper {
	overflow: hidden !important;
}

.detailDialog /deep/ .el-dialog__body {
	width: 100%;
	padding-right: 0 !important;
	padding-top: 0 !important;
	padding-left: 0 !important;
	overflow-y: auto !important;
}

.el-form-item {
	margin-bottom: 8px;
}

/deep/ .el-form-item__content {
	line-height: 28px;
}

/deep/ .return-goods-box {
	max-height: 500px;
	overflow-y: auto;
}

.refund-address {
	border: 1px solid #B1B1B1;
	padding: 10px 20px;
	box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
}

.address-title {
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
	align-items: center;
}

.address-reciver {
	display: flex;
	justify-content: space-between;
	margin-bottom: 5px;
}

.reciver-item {
	width: 45%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.address-detail {
	text-overflow: ellipsis;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
}

.radio-group {
	margin-top: 5px;
}
/* 添加定位容器 */
	.dropdown-wrapper {
		position: relative;
		width: 100%;
	}
	.contentInput {
		width:70%;
	}
	.contentInput:hover {
		cursor: pointer;
	}
	/* 自定义下拉内容 */
	.custom-dropdown {
		width:70%;
		height: 200px;
		max-height: 200px;
		position: absolute;
		top: 100%; /* 在输入框下方 */
		left: 0;
		right: 0;
		background: white;
		color:#606266;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
		z-index: 2000;
		margin-top: 2px; /* 与输入框的间距 */
		padding: 0px;
		overflow-y: auto;
	}
	.itemDown{
		height: 40px;
		line-height: 40px;
		display: flex;
		align-items: center;
		width:100%;
		font-size:15px;
	}
	.itemDown:hover {
		background-color: #dcdfe6;
	}
	.downName {
		width:calc(100% - 150px);
		padding-left: 15px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.downIcon {
		width:120px;
		padding:0 10rpx;
		display: flex;
		align-items: center;
		}
		.downIcon:hover{
			cursor: pointer;
		}
		.upload-wrapper /deep/ .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
  vertical-align: top;
}

.upload-wrapper /deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
  vertical-align: top;
}

.upload-wrapper /deep/ .el-upload--picture-card .el-icon-plus {
  font-size: 20px !important;
  color: #8c939d;
}
</style>